/* eslint-disable react/prop-types */
import React, { Fragment, useState, useEffect, useRef } from "react";
import { format } from "date-fns";
import Autocomplete from '@mui/material/Autocomplete';
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Card,
  Paper,
  Switch,
  Typography,
  Select,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Button,
  CircularProgress,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import AdmissionFormTableView from "./AdmissionFormTableView";
import {
  alphabetExp,
  numberExp,
  emailExp,
} from "../../../../utils/regularExpression";
import { Link } from "react-router-dom";
import LoginMenu from "../../../../components/LoginMenu/LoginMenu";
//import { displayName } from "react-widgets/lib/Calendar";

const styles = () => ({
  root: {
    padding: 20,
  },
  formControl: {
    minWidth: "100%",
  },
  sectionTitle: {
    fontSize: 19,
    color: "#174a84",
  },
  checkboxDividerLabel: {
    marginTop: 10,
    marginLeft: 5,
    marginRight: 20,
    fontSize: 16,
    fontWeight: 600,
  },
  rootProgress: {
    width: "100%",
    textAlign: "center",
  },
});

const useStyles = makeStyles(styles);

function isEmpty(obj) {
  if (obj == null) return true;

  if (typeof obj !== "object") return true;

  for (let key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
}

function Switches(props) {
  const [open, setOpen] = React.useState(false);
  const [dialogMsg, setDialogMsg] = React.useState("");
  const [switchState, setSwitchState] = React.useState(props.isChecked);

  const handleClickOpen = () => {
    if (switchState) {
      console.log("M Opened Now");
    } else {
      console.log("M Closed Now");
    }
    setOpen(true);
  };

  return (
    <Fragment>
      <Switch
        checked={switchState}
        //onChange={handleChange}
        onClick={handleClickOpen}
        color="primary"
        name="switch"
        inputProps={{ "aria-label": "primary checkbox" }}
      />
    </Fragment>
  );
}

const AdmissionForm = (props) => {

  const classes = useStyles();
  const selectRef = useRef(null);
  const [state, setState] = useState({
    /////////////////Applying for State///////////////////

    appliedFor: parseInt(window.localStorage.getItem("degreeId")),
    appliedForError: "",
    category: 0,
    categoryError: "",
    yearAlevel: "",
    yearAlevelError: "",
    chessSubDegree: "",
    chessSubDegreeError: "",
    appliedForDefault: "",
    disabledDegreeData: [],

    /////////////////Personal Information State///////////////////

    firstName: window.localStorage.getItem("firstName"),
    firstNameError: "",
    middleName: "",
    middleNameError: "",
    lastName: window.localStorage.getItem("lastName"),
    lastNameError: "",
    displayName:
      window.localStorage.getItem("firstName") +
      " " +
      window.localStorage.getItem("lastName"),
    displayNameError: "",
    dateOfBirth: new Date(window.localStorage.getItem("convertedDate")),
    dateOfBirthError: "",
    genderId: window.localStorage.getItem("genderId"),
    genderIdError: "",
    nationalityId: "",
    nationalityIdObject: {},
    nationalityIdError: "",
    email: window.localStorage.getItem("email"),
    emailError: "",
    mobileNo: window.localStorage.getItem("mobileNo"),
    mobileNoError: "",
    userDocumentTypeId: "",
    userDocumentTypeIdError: "",
    userNicopCnicBform: "",
    userNicopCnicBformError: "",
    userPassport: "",
    userPassportError: "",
    userBform: "",
    userBformError: "",
    userNicop: "",
    userNicopError: "",
    userMaterialStatusId: "",
    userMaterialStatusIdError: "",
    userBloodGroupId: "",
    userBloodGroupIdError: "",

    /////////////////Father Information State///////////////////

    fatherTitleId: "",
    fatherTitleIdError: "",
    fatherDocumentTypeId: "",
    fatherDocumentTypeIdError: "",
    fatherCnic: "",
    fatherCnicError: "",
    fatherPassport: "",
    fatherPassportError: "",
    fatherNicop: "",
    fatherNicopError: "",
    fatherOccupation: "",
    fatherOccupationError: "",
    fatherMobileNo: "",
    fatherMobileNoError: "",
    fatherName: "",
    fatherNameError: "",
    fatherEmail: "",
    fatherEmailError: "",

    /////////////////Mother Information State///////////////////

    motherTitleId: "",
    motherTitleIdError: "",
    motherDocumentTypeId: "",
    motherDocumentTypeIdError: "",
    motherCnic: "",
    motherCnicError: "",
    motherPassport: "",
    motherPassportError: "",
    motherNicop: "",
    motherNicopError: "",
    motherOccupation: "",
    motherOccupationError: "",
    motherMobileNo: "",
    motherMobileNoError: "",
    motherName: "",
    motherNameError: "",
    motherEmail: "",
    motherEmailError: "",

    /////////////////Guardian Information State///////////////////

    guardianInformationId: "",
    guardianInformationIdError: "",
    guardianDocumentTypeId: "",
    guardianDocumentTypeIdError: "",
    guardianTitleId: "",
    guardianTitleIdError: "",
    guardianCnic: "",
    guardianCnicError: "",
    guardianPassport: "",
    guardianPassportError: "",
    guardianNicop: "",
    guardianNicopError: "",
    guardianOccupation: "",
    guardianOccupationError: "",
    guardianMobileNo: "",
    guardianMobileNoError: "",
    guardianName: "",
    guardianNameError: "",
    guardianEmail: "",
    guardianEmailError: "",
    guardianRelationId: "",
    guardianRelationIdError: "",
    guardianRelationOther: "",
    guardianRelationOtherError: "",

    /////////////////Present Mailing Information State///////////////////

    mailingAddressId: "",
    mailingAddressIdError: "",
    presentAddress: "",
    presentAddressError: "",
    presentPostalCode: "",
    presentPostalCodeError: "",
    presentCountryId: "",
    presentCountryIdObject: {},
    presentCountryIdError: "",
    presentProvinceId: "",
    presentProvinceIdObject: {},
    presentProviceIdError: "",
    presentCityId: "",
    presentCityIdObject: {},
    presentCityIdError: "",

    permanentAddress: "",
    permanentAddressError: "",
    permanentPostalCode: "",
    permanentPostalCodeError: "",
    permanentCountryId: "",
    permanentCountryIdObject: {},
    permanentCountryIdError: "",
    permanentProvinceId: "",
    permanentProvinceIdObject: {},
    permanentProviceIdError: "",
    permanentCityId: "",
    permanentCityIdObject: {},
    permanentCityIdError: "",

    /////////////////Academics Information State///////////////////

    academicsNameOfAwardingBodySec1: "",
    academicsNameOfAwardingBodySec1Error: "",
    academicsNameOfInstitutionSec1: "",
    academicsNameOfInstitutionSec1Error: "",
    academicsQualificationSec1: "",
    academicsQualificationSec1Error: "",
    academicsYearAwardedSec1: "",
    academicsYearAwardedSec1Error: "",
    academicsIsResultAwaitedSec1: 0,
    academicsIsResultAwaitedSec1Error: "",
    academicsOverallMarksSec1: "",
    academicsOverallMarksSec1Error: "",
    academicSubjectSec1: "",
    academicSubjectSec1Error: "",
    academicGradeMarksSec1: "",
    academicGradeMarksSec1Error: "",
    academicRecordsArray: [],
    academicSec1Error: "",

    academicsNameOfAwardingBodySec2: "",
    academicsNameOfAwardingBodySec2Error: "",
    academicsNameOfInstitutionSec2: "",
    academicsNameOfInstitutionSec2Error: "",
    academicsQualificationSec2: "",
    academicsQualificationSec2Error: "",
    academicsYearAwardedSec2: "",
    academicsYearAwardedSec2Error: "",
    academicsIsResultAwaitedSec2: 0,
    academicsIsResultAwaitedSec2Error: "",
    academicsOverallMarksSec2: "",
    academicsOverallMarksSec2Error: "",
    academicSubjectSec2: "",
    academicSubjectSec2Error: "",
    academicGradeMarksSec2: "",
    academicGradeMarksSec2Error: "",
    academicSec2RecordsArray: [],
    academicSec2Error: "",

    qualificationRecordsArray: [],
    nameOfQualificationSec3: "",
    nameOfQualificationSec3Error: "",
    nameOfInstitutionSec3: "",
    nameOfInstitutionSec3Error: "",
    nameOfAwardingSec3: "",
    nameOfAwardingSec3Error: "",

    /////////////////Extra Activity Information State///////////////////

    nameOfInstitutionActivity: "",
    nameOfInstitutionActivityError: "",
    tenureActivity: "",
    tenureActivityError: "",
    mainActivity: "",
    mainActivityError: "",
    positionActivity: "",
    positionActivityError: "",
    natureOfPositionActivity: "",
    natureOfPositionActivityError: "",
    activityRecordsArray: [],

    /////////////////work Activity Information State///////////////////

    organizationWork: "",
    organizationError: "",
    tenureWork: "",
    tenureWorkError: "",
    mainWork: "",
    mainWorkError: "",
    positionWork: "",
    positionWorkError: "",
    natureOfPositionWork: "",
    natureOfPositionWorkError: "",
    workRecordsArray: [],

    /////////////////ucl relation Information State///////////////////

    relationInstitutionUcl: "",
    relationInstitutionUclError: "",
    relationIdUcl: "",
    relationIdUclError: "",
    currentStatusUcl: "",
    currentStatusUclError: "",
    relationDesignationUcl: "",
    relationDesignationUclError: "",
    relationNameUcl: "",
    relationNameUclError: "",
    relationDepartmentUcl: "",
    relationDepartmentUclError: "",
    relationProgramUcl: "",
    relationProgramUclError: "",
    relationGraduationYearUcl: "",
    relationGraduationYearUclError: "",
    uclRelationRecordsArray: [],

    ////////////////////Check Subject //////////////////////////////////
    LastEnteredIndex: 0,
    checkSubjects: [],
    checkSubjectsError: "",
    checkSubjectsGroup19: [],
    checkSubjectsGroup19Error: "",

    /////////////////A/OLevel Academics Information State///////////////////

    nameOfSchoolAlevel: "",
    nameOfSchoolAlevelError: "",
    addressOfSchoolAlevel: "",
    addressOfSchoolAlevelError: "",

    subjectAcademicAlevel: "",
    subjectAcademicAlevelError: "",
    examAcademicAlevel: "",
    examAcademicAlevelError: "",
    boardAcademicAlevel: "",
    boardAcademicAlevelError: "",
    sessionAcademicAlevel: "",
    sessionAcademicAlevelError: "",
    gradeAcademicAlevel: "",
    gradeAcademicAlevelError: "",
    aLevelAcademicError: "",
    aLevelAcademicRecordsArray: [],

    /////////////////o/A level financial State///////////////////

    nameOfPersonAlevel: "",
    nameOfPersonAlevelError: "",
    addressOfPersonAlevel: "",
    addressOfPersonAlevelError: "",
    professionOfPersonAlevel: "",
    professionOfPersonAlevelError: "",

    /////////////////Medical Data State///////////////////

    checkMedical: 0,
    medicalCondition: "",
    medicalConditionError: "",
    medicalName: "",
    medicalNameError: "",
    medicalRelationshipId: "",
    medicalRelationshipIdError: "",
    medicalMobileNumber: "",
    medicalMobileNumberError: "",

    /////////////////Other Data State///////////////////

    hearFrom: "",
    hearFromError: "",

    hearMagzineName: "",
    hearMagzineNameError: "",
    hearOtherSource: "",
    hearOtherSourceError: "",
    reasons: "",
    reasonsError: "",
    iAgreeCheck: false,
    iAgreeCheckError: "",

    isLoading: false,
    loadingData: false,
    openReview: false,
    data: {},
    genderData: [],
    degreeData: [],
    bloodGroupData: [],
    nationalityData: [],
    materialStatusData: [],
    guardianTitleData: [],
    fatherTitleData: [],
    motherTitleData: [],
    relationshipData: [],
    qualificationData: [],
    maleOccupationData: [],
    allOccupationData: [],
    transportationData: [],
    countriesData: [],
    permanentProvinceData: [],
    permanentCitiesData: [],
    presentProvinceData: [],
    presentCitiesData: [],
    documentTypeData: [],
    GuardianRelationshipData: [],
    guardianInformationData: [],
    presentAddressData: [],
    chessSubDegreeData: [],
    uclRelativeRolesData: [],
    uclRelativeInstitutionData: [],
    uclHearAboutData: [],
    aLevelSubjectCombinationData: [],
    offeredCoursesData: [],
    selectedCourseIds: [],
    selectedCourseIdsError: "",
    loadingOfferedCourses: false,
    successDialog: false,
    isLoginMenu: false,
    isReload: false,

    switchSateGroupId: 0,
  });

  const updateState = (updates) => setState(prev => ({ ...prev, ...updates }));


  useEffect(() => {
    loadData();
    todayDate();
  }, []);
  const todayDate = () => {
    let todaysDate = new Date();
    let dd = String(todaysDate.getDate()).padStart(2, "0");
    let mm = String(todaysDate.getMonth() + 1).padStart(2, "0");
    let yyyy = todaysDate.getFullYear();
    updateState({
      todaysDate: dd + "/" + mm + "/" + yyyy,
    });
  }

  const loadData = async () => {
    updateState({
      loadingData: true,
    });

    otherData();
    if (localStorage.getItem("isSaved") == 1) {
      await getData();
    }
    updateState({
      loadingData: false,
    });
  };

  const otherData = () => {
    getGenderData();
    getDegreesData();
    getBloodGroupData();
    getNationalitiesData();
    getMaterialStatusData();
    getRelationTitleDataById(1);
    getRelationTitleDataById(2);
    getRelationTitleDataById(3);
    getRelationshipData();
    getQualificationData();
    getOccupationsData(0);
    getOccupationsData(1);
    getCountriesData();
    getDocumentTypeData();
    getGuardianRelationshipData();
    getGuardianInformationData();
    getPresentAddressData();
    getChessSubDegreeData();
    getUclRelativeRoleData();
    getUclRelativeInstitutionData();
    getUclHearAboutData();
    getALevelSubjectCombinationData();
  };

  const handleSuccessDialog = () => {
    updateState({
      successDialog: !state.successDialog,
    });
  };
  const StopEnter = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  }

  const onSwitchChangedSave = (e, groupId) => {
    const { checked } = e.target;
    const checkedGroupId = checked ? groupId : 0;

    updateState({
      switchSateGroupId: checkedGroupId,
      checkSubjects: [],
    });
  };

  const getALevelSubjectCombinationData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationALevelSubjectTypesView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            aLevelSubjectCombinationData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getUclHearAboutData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationInstitutionSourceTypesView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            uclHearAboutData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getUclRelativeInstitutionData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationInstitutionsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            uclRelativeInstitutionData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getUclRelativeRoleData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationRelativesRolesView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            uclRelativeRolesData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getChessSubDegreeData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonAcademicsDegreeProgramsCHESSView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            chessSubDegreeData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getPresentAddressData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationMailingAddressTypesView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            presentAddressData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getGuardianInformationData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationGuardianTypesView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            guardianInformationData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getGuardianRelationshipData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonPersonalRelationsGuardianView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            GuardianRelationshipData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getDocumentTypeData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonIdentityDocumentTypesView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            documentTypeData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getTransportationReasonData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationTransportReasonsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            transportationData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getCountriesData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonCountriesView`;

    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        async (json) => {
          const countryObject = json.DATA.find((item) => item.ID === 165);
          updateState({
            permanentCountryId: 165,
            permanentCountryIdObject: countryObject,
            countriesData: json.DATA || [],
          });
          await getProvinceData(165, "permanent", "");
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getProvinceData = async (id, type, value = "") => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonCountriesProvincesView?countryId=${id}`;
    const name = `${type}ProvinceData`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          const valueName = `${type}ProvinceId`;
          const valueObjName = `${type}ProvinceIdObject`;
          const data = json.DATA || [];
          const id = value || "";
          const obj = value ? data.find((item) => item.ID === value) : {};
          updateState({
            [name]: data,
            [valueName]: id,
            [valueObjName]: obj,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };
  const getCitiesData = async (id, type, value = "") => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonCitiesView?provinceId=${id}`;
    const name = `${type}CitiesData`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          const valueName = `${type}CityId`;
          const valueObjName = `${type}CityIdObject`;
          const data = json.DATA || [];
          const id = value || "";
          const obj = value ? data.find((item) => item.ID === value) : {};
          updateState({
            [name]: data,
            [valueName]: id,
            [valueObjName]: obj,
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getQualificationData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationFamilyQualificationsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            qualificationData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getOccupationsData = async (isMale) => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationOccupationsView?isMale=${isMale}`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (isMale === 1) {
            updateState({
              maleOccupationData: json.DATA || [],
            });
          } else {
            updateState({
              allOccupationData: json.DATA || [],
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getGenderData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonGendersView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then((json) => {
        updateState({
          genderData: json.DATA || [],
        });
      })
      .catch((error) => {
        if (error.status == 401 && localStorage.getItem("isSaved") != 1) {
          updateState({
            isLoginMenu: true,
            isReload: true,
          });
        }
        console.log(error);
      });
  };

  const getRelationTitleDataById = async (id) => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonHonorificsView?typeId=${id}`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (id === 1) {
            updateState({
              fatherTitleData: json.DATA || [],
            });
          }
          if (id === 2) {
            updateState({
              motherTitleData: json.DATA || [],
            });
          }
          if (id === 3) {
            updateState({
              guardianTitleData: json.DATA || [],
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getBloodGroupData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonBloodGroupsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            bloodGroupData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getRelationshipData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonPersonalRelationsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            relationshipData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getNationalitiesData = async () => {
    // const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonNationalitiesView`;
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonCountriesView`;

    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          const countryObject = json.DATA.find((item) => item.ID === 165);
          updateState({
            nationalityId: 165,
            nationalityIdObject: countryObject,
            nationalityData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getMaterialStatusData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01CommonMaritalStatusView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          updateState({
            materialStatusData: json.DATA || [],
          });
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const getDegreesData = async () => {
    let data = [];
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonAcademicsDegreeProgramsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          const resData = json.DATA || [];
          if (resData.length > 0) {
            for (let i = 0; i < resData.length; i++) {
              if (!isEmpty(resData[i])) {
                data.push({ id: "", label: resData[i].department });
              }
              for (let j = 0; j < resData[i].degrees.length; j++) {
                if (!isEmpty(resData[i].degrees[j])) {
                  data.push({
                    id: resData[i].degrees[j].id,
                    label: resData[i].degrees[j].label,
                    isActive: resData[i].degrees[j].isActive,
                  });
                  if (resData[i].degrees[j].isActive == 0) {
                    state.disabledDegreeData.push({
                      id: resData[i].degrees[j].id,
                      label: resData[i].degrees[j].label,
                    });
                  }
                }
              }
            }
          }
        },
        (error) => {
          console.log("myData", error);
        }
      );
    updateState({
      degreeData: data,
    });
    console.log("disabledDegreeData", state.disabledDegreeData);
  };

  const getOfferedCoursesData = async (appliedFor) => {
    if (!appliedFor) {
      updateState({
        offeredCoursesData: [],
        selectedCourseIds: [],
        selectedCourseIdsError: "",
      });
      return;
    }
    updateState({ loadingOfferedCourses: true });
    const formData = new FormData();
    formData.append("appliedFor", appliedFor);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C01CommonAdmissionsProgrammeCoursesView`;
    try {
      const res = await fetch(url, {
        method: "POST",
        body: formData,
        headers: new Headers({
          Authorization: "Bearer " + localStorage.getItem("uclToken"),
        }),
      });
      if (!res.ok) throw res;
      const json = await res.json();
      updateState({
        offeredCoursesData: json.DATA || [],
        selectedCourseIds: [],
        selectedCourseIdsError: "",
        loadingOfferedCourses: false,
      });
    } catch (error) {
      console.log(error);
      updateState({
        offeredCoursesData: [],
        selectedCourseIds: [],
        loadingOfferedCourses: false,
      });
    }
  };

  const handleToggleCourse = (courseId) => {
    const current = state.selectedCourseIds || [];
    const exists = current.includes(courseId);
    let next;
    if (exists) {
      next = current.filter((id) => id !== courseId);
    } else {
      if (current.length >= 6) {
        updateState({
          selectedCourseIdsError: "You can select a maximum of 6 subjects.",
        });
        return;
      }
      next = [...current, courseId];
    }
    updateState({
      selectedCourseIds: next,
      selectedCourseIdsError: "",
    });
  };

  const keyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let regex = "";
    switch (name) {
      case "appliedFor":
        for (let j = 0; j < state.disabledDegreeData.length; j++) {
          if (value === state.disabledDegreeData[j].id) {
            if (value != state.appliedForDefault) {
              alert("Admission for this programme is closed.");
              updateState({
                appliedFor: "",
                offeredCoursesData: [],
                selectedCourseIds: [],
                selectedCourseIdsError: "",
              });
              return;
            }
          }
        }
        getOfferedCoursesData(value);
        break;
      case "firstName":
      case "middleName":
      case "lastName":
      case "displayName":
      case "fatherName":
      case "motherName":
      case "guardianName":
      case "relativeNameUcl":
      case "nameOfPersonAlevel":
        regex = new RegExp(alphabetExp);
        if (value && !regex.test(value)) {
          return;
        }
        break;
      case "relationshipAge":
      case "mobileNo":
      case "fatherMobileNo":
      case "motherMobileNo":
      case "guardianMobileNo":
      case "userNicopCnicBform":
      case "userNicop":
      case "fatherCnic":
      case "motherCnic":
      case "guardianCnic":
      case "fatherNicop":
      case "motherNicop":
      case "guardianNicop":
      case "permanentMobileNumber":
      case "permanentPostalCode":
      case "presentMobileNumber":
      case "presentPostalCode":
      case "medicalMobileNumber":
      case "academicsYearAwardedSec1":
      case "academicsYearAwardedSec2":
      case "relationGraduationYearUcl":
      case "tenureActivity":
      case "tenureWork":
        regex = new RegExp(numberExp);
        if (value && !regex.test(value)) {
          return;
        }
        break;
      default:
        break;
    }
    if (name === "fatherTitleId" && value === 6) {
      updateState({
        fatherEmail: "",
        fatherEmailError: "",
        fatherMobileNo: "",
        fatherMobileNoError: "",
        fatherOccupation: "",
        fatherOccupationError: "",
        fatherDocumentTypeId: "",
        fatherDocumentTypeIdError: "",
        fatherCnic: "",
        fatherCnicError: "",
        fatherPassport: "",
        fatherPassportError: "",
        fatherNicop: "",
        fatherNicopError: "",
      });
    }
    if (name === "motherTitleId" && value === 6) {
      updateState({
        motherEmail: "",
        motherEmailError: "",
        motherMobileNo: "",
        motherMobileNoError: "",
        motherOccupation: "",
        motherOccupationError: "",
        motherDocumentTypeId: "",
        motherDocumentTypeIdError: "",
        motherCnic: "",
        motherCnicError: "",
        motherPassport: "",
        motherPassportError: "",
        motherNicop: "",
        motherNicopError: "",
      });
    }
    if (name === "guardianInformationId" && value !== 3) {
      updateState({
        guardianName: "",
        guardianNameError: "",
        guardianRelationId: "",
        guardianRelationIdError: "",
        guardianTitleId: "",
        guardianTitleIdError: "",
        guardianEmail: "",
        guardianEmailError: "",
        guardianMobileNo: "",
        guardianMobileNoError: "",
        guardianOccupation: "",
        guardianOccupationError: "",
        guardianDocumentTypeId: "",
        guardianDocumentTypeIdError: "",
        guardianCnic: "",
        guardianCnicError: "",
        guardianPassport: "",
        guardianPassportError: "",
        guardianNicop: "",
        guardianNicopError: "",
      });
    }

    if (name === "currentStatusUcl" && value === 1) {
      updateState({
        relationDesignationUcl: "",
        relationDesignationUclError: "",
      });
    }
    if (name === "currentStatusUcl" && value !== 1) {
      updateState({
        relationProgramUcl: "",
        relationProgramUclError: "",
      });
    }

    if (name === "hearFrom") {
      updateState({
        hearOtherSource: "",
        hearOtherSourceError: "",
        hearMagzineName: "",
        hearMagzineNameError: "",
      });
    }

    if (name === "fatherDocumentTypeId") {
      updateState({
        fatherCnic: "",
        fatherCnicError: "",
        fatherPassport: "",
        fatherPassportError: "",
        fatherNicop: "",
        fatherNicopError: "",
      });
    }

    if (name === "userDocumentTypeId") {
      updateState({
        userNicopCnicBform: "",
        userNicopCnicBformError: "",
        userPassport: "",
        userPassportError: "",
        userNicop: "",
        userNicopError: "",
      });
    }

    if (name === "motherDocumentTypeId") {
      updateState({
        motherCnic: "",
        motherCnicError: "",
        motherPassport: "",
        motherPassportError: "",
        motherNicop: "",
        motherNicopError: "",
      });
    }

    if (name === "guardianDocumentTypeId") {
      updateState({
        guardianCnic: "",
        guardianCnicError: "",
        guardianPassport: "",
        guardianPassportError: "",
        guardianNicop: "",
        guardianNicopError: "",
      });
    }

    if (name === "appliedFor") {
      if (value !== 32) {
        updateState({
          aLevelAcademicError: "",
          aLevelAcademicRecordsArray: [],
          yearAlevel: "",
          yearAlevelError: "",
          subjectAcademicAlevel: "",
          subjectAcademicAlevelError: "",
          gradeAcademicAlevel: "",
          gradeAcademicAlevelError: "",
          nameOfSchoolAlevel: "",
          nameOfSchoolAlevelError: "",
          addressOfSchoolAlevel: "",
          addressOfSchoolAlevelError: "",
          nameOfPersonAlevel: "",
          nameOfPersonAlevelError: "",
          addressOfPersonAlevel: "",
          addressOfPersonAlevelError: "",
          professionOfPersonAlevel: "",
          professionOfPersonAlevelError: "",
          chessSubDegree: "",
          chessSubDegreeError: "",
          checkSubjects: [],
          checkSubjectsGroup19: [],
        });
      } else {
        updateState({
          academicsNameOfAwardingBodySec1: "",
          academicsNameOfAwardingBodySec1Error: "",
          academicsNameOfInstitutionSec1: "",
          academicsNameOfInstitutionSec1Error: "",
          academicsQualificationSec1: "",
          academicsQualificationSec1Error: "",
          academicsYearAwardedSec1: "",
          academicsYearAwardedSec1Error: "",
          academicsIsResultAwaitedSec1: 0,
          academicsIsResultAwaitedSec1Error: "",
          academicsOverallMarksSec1: "",
          academicsOverallMarksSec1Error: "",
          academicSubjectSec1: "",
          academicSubjectSec1Error: "",
          academicGradeMarksSec1: "",
          academicGradeMarksSec1Error: "",
          academicRecordsArray: [],
          academicSec1Error: "",

          academicsNameOfAwardingBodySec2: "",
          academicsNameOfAwardingBodySec2Error: "",
          academicsNameOfInstitutionSec2: "",
          academicsNameOfInstitutionSec2Error: "",
          academicsQualificationSec2: "",
          academicsQualificationSec2Error: "",
          academicsYearAwardedSec2: "",
          academicsYearAwardedSec2Error: "",
          academicsIsResultAwaitedSec2: 0,
          academicsIsResultAwaitedSec2Error: "",
          academicsOverallMarksSec2: "",
          academicsOverallMarksSec2Error: "",
          academicSubjectSec2: "",
          academicSubjectSec2Error: "",
          academicGradeMarksSec2: "",
          academicGradeMarksSec2Error: "",
          academicSec2RecordsArray: [],
          academicSec2Error: "",

          organizationWork: "",
          organizationError: "",
          tenureWork: "",
          tenureWorkError: "",
          mainWork: "",
          mainWorkError: "",
          positionWork: "",
          positionWorkError: "",
          natureOfPositionWork: "",
          natureOfPositionWorkError: "",
          workRecordsArray: [],
          chessSubDegree: "",
          chessSubDegreeError: "",
        });
      }
    }

    if (name === "currentStatusUcl") {
      if (value === 1 || value === 4) {
        updateState({
          relationDesignationUcl: "",
          relationDesignationUclError: "",
          relationDepartmentUcl: "",
          relationDepartmentUclError: "",
        });
      }
      if (value !== 4) {
        updateState({
          relationGraduationYearUcl: "",
          relationGraduationYearUclError: "",
        });
      }
      if (value !== 1 && value !== 4) {
        updateState({
          relationProgramUcl: "",
          relationProgramUclError: "",
        });
      }
    }

    updateState({
      [name]: value,
      [errName]: "",
    });
  };

  const handleAutoComplete = (name) => (e, value) => {
    const errName = `${name}Error`;
    const objState = `${name}Object`;
    if (isEmpty(value)) {
      switch (name) {
        case "permanentCountryId":
          updateState({
            permanentProvinceData: [],
            permanentProviceIdError: "",
            permanentProvinceIdObject: {},
            permanentProvinceId: "",

            permanentCitiesData: [],
            permanentCityId: "",
            permanentCityIdError: "",
            permanentCityIdObject: {},
          });
          break;
        case "permanentProvinceId":
          updateState({
            permanentCitiesData: [],
            permanentCityId: "",
            permanentCityIdError: "",
            permanentCityIdObject: {},
          });
          break;
        case "presentCountryId":
          updateState({
            presentProvinceData: [],
            presentProviceIdError: "",
            presentProvinceIdObject: {},
            presentProvinceId: "",

            presentCitiesData: [],
            presentCityId: "",
            presentCityIdError: "",
            presentCityIdObject: {},
          });
          break;
        case "presentProvinceId":
          updateState({
            presentCitiesData: [],
            presentCityId: "",
            presentCityIdError: "",
            presentCityIdObject: {},
          });
          break;
        default:
          break;
      }
      updateState({
        [name]: "",
        [errName]: "",
        [objState]: {},
      });
    } else {
      const { ID } = value;
      switch (name) {
        case "permanentCountryId":
          updateState({
            permanentProvinceData: [],
            permanentProviceIdError: "",
            permanentProvinceIdObject: {},
            permanentProvinceId: "",

            permanentCitiesData: [],
            permanentCityId: "",
            permanentCityIdError: "",
            permanentCityIdObject: {},
          });
          getProvinceData(ID, "permanent", "");
          break;
        case "permanentProvinceId":
          updateState({
            permanentCitiesData: [],
            permanentCityId: "",
            permanentCityIdError: "",
            permanentCityIdObject: {},
          });
          getCitiesData(ID, "permanent", "");
          break;
        case "presentCountryId":
          updateState({
            presentProvinceData: [],
            presentProviceIdError: "",
            presentProvinceIdObject: {},
            presentProvinceId: "",

            presentCitiesData: [],
            presentCityId: "",
            presentCityIdError: "",
            presentCityIdObject: {},
          });
          getProvinceData(ID, "present", "");
          break;
        case "presentProvinceId":
          updateState({
            presentCitiesData: [],
            presentCityId: "",
            presentCityIdError: "",
            presentCityIdObject: {},
          });
          getCitiesData(ID, "present", "");
          break;
        default:
          break;
      }
      updateState({
        [name]: ID,
        [errName]: "",
        [objState]: value,
      });
    }
  };

  const handleDateChange = (date) => {
    updateState({
      dateOfBirth: date,
      dateOfBirthError: "",
    });
    console.log(date);
  };

  const onRelationShipRemoveClick = (event, index) => {
    let { relationshipRecordsArray } = state;
    relationshipRecordsArray.splice(index, 1);
    updateState({
      relationshipRecordsArray,
    });
  };

  const onAlevelAcademicRemoveClick = (event, index) => {
    let { aLevelAcademicRecordsArray } = state;
    aLevelAcademicRecordsArray.splice(index, 1);
    updateState({
      aLevelAcademicRecordsArray,
    });
  };

  const onUclRelationRemoveClick = (event, index) => {
    let { uclRelationRecordsArray } = state;
    uclRelationRecordsArray.splice(index, 1);
    updateState({
      uclRelationRecordsArray,
    });
  };

  const onAcademicsRemoveClick = (event, index) => {
    let { academicRecordsArray } = state;
    academicRecordsArray.splice(index, 1);
    updateState({
      academicRecordsArray,
    });
  };

  const onActivityRemoveClick = (event, index) => {
    let { activityRecordsArray } = state;
    activityRecordsArray.splice(index, 1);
    updateState({
      activityRecordsArray,
    });
  };

  const onAcademicsSec2RemoveClick = (event, index) => {
    let { academicSec2RecordsArray } = state;
    academicSec2RecordsArray.splice(index, 1);
    updateState({
      academicSec2RecordsArray,
    });
  };

  const onQualificationRemoveClick = (event, index) => {
    let { qualificationRecordsArray } = state;
    qualificationRecordsArray.splice(index, 1);
    updateState({
      qualificationRecordsArray,
    });
  };

  const onWorkRemoveClick = (event, index) => {
    let { workRecordsArray } = state;
    workRecordsArray.splice(index, 1);
    updateState({
      workRecordsArray,
    });
  };

  const onRelationShipAddClick = () => {
    const { relationshipData, qualificationData } = state;
    let {
      userRelationshipId,
      relationshipQualificationId,
      relationshipAge,
      relationshipSalary,
      userRelationshipIdError,
      relationshipSalaryError,
      relationshipAgeError,
      relationshipQualificationIdError,
      relationshipRecordsArray,
    } = state;
    if (!userRelationshipId) {
      userRelationshipIdError = "Please select a relation.";
    } else if (!relationshipQualificationId) {
      relationshipQualificationIdError = "Please select a qualification.";
    } else if (!relationshipAge) {
      relationshipAgeError = "Please enter age";
    } else if (!relationshipSalary) {
      relationshipSalaryError = "Please enter salary";
    } else {
      const findRRecord = relationshipData.find(
        (item) => item.ID === userRelationshipId
      );
      const findQRecord = qualificationData.find(
        (item) => item.ID === relationshipQualificationId
      );
      const obj = {
        relationship: findRRecord.Label,
        qualification: findQRecord.Label,
        age: relationshipAge,
        salary: relationshipSalary,
        qualificationId: findQRecord.ID,
        relationshipId: findRRecord.ID,
      };
      relationshipRecordsArray.push(obj);
      userRelationshipId = "";
      relationshipSalary = "";
      relationshipAge = "";
      relationshipQualificationId = "";
    }
    updateState({
      relationshipRecordsArray,
      userRelationshipIdError,
      relationshipSalaryError,
      relationshipAgeError,
      relationshipQualificationIdError,
      relationshipSalary,
      relationshipAge,
      relationshipQualificationId,
      userRelationshipId,
    });
  };

  const onUclRelationAddClick = () => {
    let {
      relationInstitutionUcl,
      relationInstitutionUclError,
      relationIdUcl,
      relationIdUclError,
      currentStatusUcl,
      currentStatusUclError,
      relationDesignationUcl,
      relationDesignationUclError,
      relationNameUcl,
      relationNameUclError,
      relationDepartmentUcl,
      relationDepartmentUclError,
      relationProgramUcl,
      relationProgramUclError,
      uclRelationRecordsArray,
      relationGraduationYearUcl,
      relationGraduationYearUclError,
    } = state;
    if (!relationInstitutionUcl) {
      relationInstitutionUclError = "Please select institution.";
    } else if (!relationIdUcl) {
      relationIdUclError = "Please enter relationship.";
    } else if (!currentStatusUcl) {
      currentStatusUclError = "Please select status";
    } else if (
      !relationDesignationUcl &&
      currentStatusUcl !== 1 &&
      currentStatusUcl !== 4
    ) {
      relationDesignationUclError = "Please enter designation.";
    } else if (!relationNameUcl) {
      relationNameUclError = "Please enter name";
    } else if (
      !relationDepartmentUcl &&
      currentStatusUcl !== 1 &&
      currentStatusUcl !== 4
    ) {
      relationDepartmentUclError = "Please enter department";
    } else if (
      !relationProgramUcl &&
      (currentStatusUcl === 1 || currentStatusUcl === 4)
    ) {
      relationProgramUclError = "Please enter Programme";
    } else if (!relationGraduationYearUcl && currentStatusUcl === 4) {
      relationGraduationYearUclError = "Please enter graduation year";
    } else {
      const { uclRelativeRolesData, uclRelativeInstitutionData } = state;
      const findRole =
        uclRelativeRolesData.find((item) => item.ID === currentStatusUcl) || {};
      const findInstitution =
        uclRelativeInstitutionData.find(
          (item) => item.ID === relationInstitutionUcl
        ) || {};
      const obj = {
        institution: findInstitution.Label,
        relationship: relationIdUcl,
        status: findRole.Label,
        designation: relationDesignationUcl || "",
        name2: relationNameUcl,
        department: relationDepartmentUcl || "",
        program: relationProgramUcl || "",
        year: relationGraduationYearUcl || "",
        uclRoleId: findRole.ID,
        uclInstitutionId: findInstitution.ID,
      };
      uclRelationRecordsArray.push(obj);
      relationInstitutionUcl = "";
      relationIdUcl = "";
      currentStatusUcl = "";
      relationDesignationUcl = "";
      relationNameUcl = "";
      relationDepartmentUcl = "";
      relationProgramUcl = "";
      relationGraduationYearUcl = "";
    }
    updateState({
      relationInstitutionUcl,
      relationInstitutionUclError,
      relationIdUcl,
      relationIdUclError,
      currentStatusUcl,
      currentStatusUclError,
      relationDesignationUcl,
      relationDesignationUclError,
      relationNameUcl,
      relationNameUclError,
      relationDepartmentUcl,
      relationDepartmentUclError,
      relationProgramUcl,
      relationProgramUclError,
      relationGraduationYearUcl,
      relationGraduationYearUclError,
    });
  };

  const onAcademicAddClick = () => {
    let {
      academicRecordsArray,
      academicSubjectSec1,
      academicSubjectSec1Error,
      academicGradeMarksSec1,
      academicGradeMarksSec1Error,
    } = state;

    let isValid = true;

    if (!academicSubjectSec1) {
      isValid = false;
      academicSubjectSec1Error = "Please enter subject.";
    } else {

      if (state.academicsIsResultAwaitedSec1 != 1) {
        if (!academicGradeMarksSec1) {
          isValid = false;
          academicGradeMarksSec1Error = "Please enter grade / marks.";
        } else {
          if (academicGradeMarksSec1.length >= 10) {
            isValid = false;
            academicGradeMarksSec1Error =
              "Please enter a valid value for grade / marks.";
          }
        }
      }
    }

    if (isValid) {
      const obj = {
        subject: academicSubjectSec1,
        gradeMarks: academicGradeMarksSec1,
      };
      academicRecordsArray.push(obj);
      academicSubjectSec1 = "";
      academicGradeMarksSec1 = "";
    }


    updateState({
      academicRecordsArray,
      academicSubjectSec1,
      academicSubjectSec1Error,
      academicGradeMarksSec1,
      academicGradeMarksSec1Error,
      academicSec1Error: "",
    });
  };

  const onAlevelAcademicAddClick = () => {
    let {
      subjectAcademicAlevel,
      subjectAcademicAlevelError,
      examAcademicAlevel,
      examAcademicAlevelError,
      boardAcademicAlevel,
      boardAcademicAlevelError,
      sessionAcademicAlevel,
      sessionAcademicAlevelError,
      gradeAcademicAlevel,
      gradeAcademicAlevelError,
      aLevelAcademicRecordsArray,
    } = state;

    if (!subjectAcademicAlevel) {
      subjectAcademicAlevelError = "Please enter subject.";
    } else if (!examAcademicAlevel) {
      examAcademicAlevelError = "Please enter exam title.";
    } else if (!boardAcademicAlevel) {
      boardAcademicAlevelError = "Please enter board.";
    } else if (!sessionAcademicAlevel) {
      sessionAcademicAlevelError = "Please enter session.";
    } else if (!gradeAcademicAlevel) {
      gradeAcademicAlevelError = "Please enter grade.";
    } else {
      if (gradeAcademicAlevel.length < 10) {
        const obj = {
          subject: subjectAcademicAlevel,
          exam: examAcademicAlevel,
          board: boardAcademicAlevel,
          session: sessionAcademicAlevel,
          grade: gradeAcademicAlevel,
        };
        aLevelAcademicRecordsArray.push(obj);
        subjectAcademicAlevel = "";
        examAcademicAlevel = "";
        boardAcademicAlevel = "";
        sessionAcademicAlevel = "";
        gradeAcademicAlevel = "";
      } else {
        gradeAcademicAlevelError = "Please enter a valid value grade.";
      }
    }
    updateState({
      subjectAcademicAlevel,
      subjectAcademicAlevelError,
      examAcademicAlevel,
      examAcademicAlevelError,
      boardAcademicAlevel,
      boardAcademicAlevelError,
      sessionAcademicAlevel,
      sessionAcademicAlevelError,
      gradeAcademicAlevel,
      gradeAcademicAlevelError,
      aLevelAcademicRecordsArray,
      aLevelAcademicError: "",
    });
  };

  const onAcademicSec2AddClick = () => {
    let {
      academicSec2RecordsArray,
      academicSubjectSec2,
      academicSubjectSec2Error,
      academicGradeMarksSec2,
      academicGradeMarksSec2Error,
    } = state;

    let isValid = true;

    if (!academicSubjectSec2) {
      isValid = false;
      academicSubjectSec2Error = "Please enter subject.";
    } else {
      if (state.academicsIsResultAwaitedSec2 != 1) {
        if (!academicGradeMarksSec2) {
          isValid = false;
          academicGradeMarksSec2Error = "Please enter grade / marks.";
        } else {
          if (academicGradeMarksSec2.length >= 10) {
            isValid = false;
            academicGradeMarksSec2Error =
              "Please enter a valid value for grade / marks.";
          }
        }
      }
    }

    if (isValid) {
      const obj = {
        subject: academicSubjectSec2,
        gradeMarks: academicGradeMarksSec2,
      };
      academicSec2RecordsArray.push(obj);
      academicSubjectSec2 = "";
      academicGradeMarksSec2 = "";
    }
    updateState({
      academicSec2RecordsArray,
      academicSubjectSec2,
      academicSubjectSec2Error,
      academicGradeMarksSec2,
      academicGradeMarksSec2Error,
      academicSec2Error: "",
    });
  };

  const onQualificationAddClick = () => {
    let {
      qualificationRecordsArray,
      nameOfQualificationSec3,
      nameOfQualificationSec3Error,
      nameOfInstitutionSec3,
      nameOfInstitutionSec3Error,
      nameOfAwardingSec3,
      nameOfAwardingSec3Error,
    } = state;
    if (!nameOfAwardingSec3) {
      nameOfAwardingSec3Error = "Please enter name of awarding.";
    } else if (!nameOfInstitutionSec3) {
      nameOfInstitutionSec3Error = "Please enter institution.";
    } else if (!nameOfQualificationSec3) {
      nameOfQualificationSec3Error = "Please enter qualification.";
    } else {
      const obj = {
        nameAward: nameOfAwardingSec3,
        nameInstitution: nameOfInstitutionSec3,
        qualification: nameOfQualificationSec3,
      };
      qualificationRecordsArray.push(obj);
      nameOfAwardingSec3 = "";
      nameOfInstitutionSec3 = "";
      nameOfQualificationSec3 = "";
    }
    updateState({
      qualificationRecordsArray,
      nameOfQualificationSec3,
      nameOfQualificationSec3Error,
      nameOfInstitutionSec3,
      nameOfInstitutionSec3Error,
      nameOfAwardingSec3,
      nameOfAwardingSec3Error,
    });
  };

  const onActivityAddClick = () => {
    let {
      nameOfInstitutionActivity,
      nameOfInstitutionActivityError,
      tenureActivity,
      tenureActivityError,
      mainActivity,
      mainActivityError,
      positionActivity,
      positionActivityError,
      natureOfPositionActivity,
      natureOfPositionActivityError,
      activityRecordsArray,
    } = state;
    if (!nameOfInstitutionActivity) {
      nameOfInstitutionActivityError = "Please enter name of institution.";
    } else if (!tenureActivity) {
      tenureActivityError = "Please enter tenure.";
    } else if (!mainActivity) {
      mainActivityError = "Please enter activity.";
    } else if (!positionActivity) {
      positionActivityError = "Please enter position.";
    } else if (!natureOfPositionActivity) {
      natureOfPositionActivityError = "Please enter  nature of position held.";
    } else {
      const obj = {
        institution: nameOfInstitutionActivity,
        tenure: tenureActivity,
        activity: mainActivity,
        position: positionActivity,
        nature: natureOfPositionActivity,
      };
      activityRecordsArray.push(obj);
      nameOfInstitutionActivity = "";
      tenureActivity = "";
      mainActivity = "";
      positionActivity = "";
      natureOfPositionActivity = "";
    }
    updateState({
      nameOfInstitutionActivity,
      nameOfInstitutionActivityError,
      tenureActivity,
      tenureActivityError,
      mainActivity,
      mainActivityError,
      positionActivity,
      positionActivityError,
      natureOfPositionActivity,
      natureOfPositionActivityError,
      activityRecordsArray,
    });
  };

  const onWorkAddClick = () => {
    let {
      organizationWork,
      organizationWorkError,
      tenureWork,
      tenureWorkError,
      mainWork,
      mainWorkError,
      positionWork,
      positionWorkError,
      natureOfPositionWork,
      natureOfPositionWorkError,
      workRecordsArray,
    } = state;
    if (!organizationWork) {
      organizationWorkError = "Please enter organization.";
    } else if (!tenureWork) {
      tenureWorkError = "Please enter tenure.";
    } else if (!mainWork) {
      mainWorkError = "Please enter Work.";
    } else if (!positionWork) {
      positionWorkError = "Please enter position.";
    } else if (!natureOfPositionWork) {
      natureOfPositionWorkError = "Please enter nature of position held.";
    } else {
      const obj = {
        organization: organizationWork,
        tenure: tenureWork,
        activity: mainWork,
        position: positionWork,
        nature: natureOfPositionWork,
      };
      workRecordsArray.push(obj);
      organizationWork = "";
      tenureWork = "";
      mainWork = "";
      positionWork = "";
      natureOfPositionWork = "";
    }
    updateState({
      organizationWork,
      organizationWorkError,
      tenureWork,
      tenureWorkError,
      mainWork,
      mainWorkError,
      positionWork,
      positionWorkError,
      natureOfPositionWork,
      natureOfPositionWorkError,
      workRecordsArray,
    });
  };

  const handleCustomChange = (e, type) => {
    updateState({
      checkMedical: type,
      medicalMobileNumber: "",
      medicalMobileNumberError: "",
      medicalName: "",
      medicalNameError: "",
      medicalRelationshipId: "",
      medicalRelationshipIdError: "",
      medicalCondition: "",
      medicalConditionError: "",
    });
  };

  /*WORKING CODE COMMENTED BY FARHAN*/
  const handleCheckGroupHandleChange = (e, i, sId, sLabel) => {
    const { checked } = e.target;
    console.log(checked, i, sId, sLabel);
    let { checkSubjectsGroup19 } = state;
    let t = -1;
    if (checked) {
      t = sId;
    }

    let arrayLenght = 0;
    for (let j = 0; j < state.checkSubjects.length; j++) {
      if (state.checkSubjects[j].checked !== -1) {
        arrayLenght++;
      }
    }

    if (arrayLenght <= 3) {
      const index = checkSubjectsGroup19.findIndex((item) => item.grpId === i);
      if (index != -1) {
        checkSubjectsGroup19[index].id = sId;
        checkSubjectsGroup19[index].checked = t;
        checkSubjectsGroup19[index].label = sLabel;
      } else {
        checkSubjectsGroup19.push({
          id: sId,
          checked: t,
          label: sLabel,
          grpId: i,
        });
      }
    }

    updateState({
      checkSubjectsGroup19,
    });
  };

  // handleCheckGroup1HandleChange = (e, i, sId, sLabel) => {

  //     console.log("BEFORE state.checkSubjects ==>> ",[...state.checkSubjects]);
  //         const { checked } = e.target;

  //         let { checkSubjects } = state;
  //         let t = -1;
  //         if (checked) {
  //             t = sId;
  //         }

  //         const index = checkSubjects.findIndex(item => item.checked === sId)

  //         if (index != -1) {

  //                 checkSubjects.splice(index,1);

  //         } else {
  //             let arrayLenght=0;
  //             for(let j=0;j<state.checkSubjects.length;j++){

  //                 if(state.checkSubjects[j].grpId==1){
  //                     arrayLenght++;
  //                 }
  //             }

  //             if(arrayLenght<3 && i==1){

  //                 checkSubjects.push({
  //                     id: sId, checked: t, label: sLabel, grpId: i
  //                 })

  //             }else if(arrayLenght>=3 && i==1){

  //                 checkSubjects.splice(state.LastEnteredIndex,1);
  //                 checkSubjects.push({
  //                     id: sId, checked: t, label: sLabel, grpId: i
  //                 })
  //             }

  //         }

  //         const indexCurrentlyEntered = checkSubjects.findIndex(item => item.checked === sId)

  //         updateState({
  //             checkSubjects,
  //             LastEnteredIndex:indexCurrentlyEntered
  //         })
  // }

  const handleCheckGroup2HandleChange = (e, i, sId, sLabel) => {
    // console.log("BEFORE state.checkSubjects ==>> ",[...state.checkSubjects]);
    const { checked } = e.target;

    let checkSubjects = [...state.checkSubjects];
    let t = -1;
    if (checked) {
      t = sId;
    }

    const indexOfSepecificSubject = checkSubjects.findIndex(
      (item) => item.checked === sId && item.grpId === i
    );

    console.log(
      "AFTER state.checkSubjects ==>> ",
      state.checkSubjects
    );
    if (state.checkSubjects.length == 0) {
      checkSubjects.push({
        id: sId,
        checked: t,
        label: sLabel,
        grpId: i,
      });
    } else {
      const index = checkSubjects.findIndex((item) => item.grpId === i);

      if (index != -1) {
        let arrayLenght = 0;
        for (let j = 0; j < checkSubjects.length; j++) {
          if (checkSubjects[j].grpId == i) {
            arrayLenght++;
          }
        }

        let arrayLenghtGroup19 = 0;

        for (let j = 0; j < state.checkSubjectsGroup19.length; j++) {
          if (state.checkSubjectsGroup19[j].checked !== -1) {
            arrayLenghtGroup19++;
          }
        }

        if (arrayLenght < 3) {
          if (indexOfSepecificSubject != -1) {
            checkSubjects[indexOfSepecificSubject].id = sId;
            checkSubjects[indexOfSepecificSubject].checked = t;
            checkSubjects[indexOfSepecificSubject].label = sLabel;
          } else {
            checkSubjects.push({
              id: sId,
              checked: t,
              label: sLabel,
              grpId: i,
            });
          }
        } else if (arrayLenght >= 3) {
          // if(arrayLenghtGroup19>0){
          //     checkSubjects.splice(state.LastEnteredIndex,1);
          // }

          if (indexOfSepecificSubject != -1) {
            checkSubjects[indexOfSepecificSubject].id = sId;
            checkSubjects[indexOfSepecificSubject].checked = t;
            checkSubjects[indexOfSepecificSubject].label = sLabel;
          } else {
            if (arrayLenghtGroup19 > 0) {
              // checkSubjects[state.LastEnteredIndex].checked = -1;
              checkSubjects.splice(state.LastEnteredIndex, 1);
            }
            checkSubjects.push({
              id: sId,
              checked: t,
              label: sLabel,
              grpId: i,
            });
          }
        }
      } else {
        checkSubjects = [];

        checkSubjects.push({
          id: sId,
          checked: t,
          label: sLabel,
          grpId: i,
        });
      }
    }

    // if (index != -1) {

    //         checkSubjects.splice(index,1);

    // } else {
    //     let arrayLenght=0;
    //     for(let j=0;j<state.checkSubjects.length;j++){

    //         if(state.checkSubjects[j].grpId==i){
    //             arrayLenght++;
    //         }
    //     }

    //     if(arrayLenght<3 ){

    //         checkSubjects.push({
    //             id: sId, checked: t, label: sLabel, grpId: i
    //         })

    //     }else if(arrayLenght>=3 ){

    //         checkSubjects.splice(state.LastEnteredIndex,1);
    //         checkSubjects.push({
    //             id: sId, checked: t, label: sLabel, grpId: i
    //         })
    //     }

    // }

    const indexCurrentlyEntered = checkSubjects.findIndex(
      (item) => item.checked === sId && item.grpId === i
    );

    console.log("AFTER state.checkSubjects ==>> ", checkSubjects);

    updateState({ checkSubjects, LastEnteredIndex: indexCurrentlyEntered });
  };

  const cnicCheckHandling = (event) => {
    const { name } = event.target;
    const errorName = `${name}Error`;
    let val = event.target.value.replace(/\D/g, "");
    val = val.substr(0, 13);
    let len = val.length;
    let formatedValue = val;
    if (len >= 6) {
      formatedValue = val.substr(0, 5) + "-" + val.substr(5, len);
    }
    if (len >= 13) {
      formatedValue = formatedValue.substr(0, 13) + "-" + val.substr(12, 1);
    }
    if (len <= 13) {
      updateState({ [name]: formatedValue, [errorName]: "" });
    }
  };

  const isFormValid = () => {
    let isValid = true;
    let regex = "";
    let {
      iAgreeCheckError,
      reasonsError,
      hearFromError,
      hearMagzineNameError,
      hearOtherSourceError,
      checkMedicalError,
      medicalMobileNumberError,
      medicalRelationshipIdError,
      medicalNameError,
      medicalConditionError,
      academicSec2Error,
      academicsOverallMarksSec2Error,
      academicsIsResultAwaitedSec2Error,
      academicsYearAwardedSec2Error,
      academicsQualificationSec2Error,
      academicsNameOfInstitutionSec2Error,
      academicsNameOfAwardingBodySec2Error,
      academicSec1Error,
      academicsOverallMarksSec1Error,
      academicsIsResultAwaitedSec1Error,
      academicsYearAwardedSec1Error,
      academicsQualificationSec1Error,
      academicsNameOfInstitutionSec1Error,
      academicsNameOfAwardingBodySec1Error,
      guardianInformationIdError,
      guardianOccupationError,
      guardianEmailError,
      guardianMobileNoError,
      guardianRelationIdError,
      guardianRelationOtherError,
      guardianDocumentTypeIdError,
      guardianCnicError,
      guardianPassportError,
      guardianNicopError,
      guardianNameError,
      guardianTitleIdError,
      motherOccupationError,
      motherEmailError,
      motherMobileNoError,
      motherDocumentTypeIdError,
      motherCnicError,
      motherPassportError,
      motherNicopError,
      motherNameError,
      motherTitleIdError,
      fatherOccupationError,
      fatherEmailError,
      fatherMobileNoError,
      fatherDocumentTypeIdError,
      fatherCnicError,
      fatherPassportError,
      fatherNicopError,
      fatherNameError,
      fatherTitleIdError,
      mailingAddressIdError,
      presentAddressError,
      presentCityIdError,
      presentCountryIdError,
      presentPostalCodeError,
      presentProvinceIdError,
      permanentAddressError,
      permanentCityIdError,
      permanentCountryIdError,
      permanentPostalCodeError,
      permanentProvinceIdError,
      userMaterialStatusIdError,
      userBloodGroupIdError,
      userDocumentTypeIdError,
      userNicopCnicBformError,
      userPassportError,
      userNicopError,
      nationalityIdError,
      mobileNoError,
      emailError,
      genderIdError,
      dateOfBirthError,
      firstNameError,
      lastNameError,
      displayNameError,
      appliedForError,
      yearAlevelError,
      chessSubDegreeError,
      aLevelAcademicError,
      nameOfSchoolAlevelError,
      checkSubjectsError,
      addressOfSchoolAlevelError,
      nameOfPersonAlevelError,
      addressOfPersonAlevelError,
      professionOfPersonAlevelError,
      checkSubjectsGroup19Error,
    } = state;
    if (!state.iAgreeCheck) {
      iAgreeCheckError = "Please check to agree our terms and condition.";
      document.getElementById("iAgreeCheck").focus();
      isValid = false;
    } else {
      iAgreeCheckError = "";
    }

    if (!state.reasons) {
      reasonsError =
        "Please specify the reason for applying under 1000 characters.";
      document.getElementById("reasons").focus();
      isValid = false;
    } else {
      reasonsError = "";
    }

    if (!state.hearFrom) {
      hearFromError = "Please select the source.";
      document.getElementById("hearFrom").focus();
      isValid = false;
    } else {
      hearFromError = "";
      if (state.hearFrom === 1 && !state.hearMagzineName) {
        hearMagzineNameError = "Please enter the news / magzine name.";
        document.getElementById("hearMagzineName").focus();
        isValid = false;
      } else {
        hearMagzineNameError = "";
      }
      if (state.hearFrom === 5 && !state.hearOtherSource) {
        hearOtherSourceError = "Please specify the other source.";
        document.getElementById("hearOtherSource").focus();
        isValid = false;
      } else {
        hearOtherSourceError = "";
      }
    }

    if (state.checkMedical === 1) {
      if (!state.medicalMobileNumber) {
        medicalMobileNumberError =
          "Please enter valid mobile number e.g 03001234567.";
        document.getElementById("medicalMobileNumber").focus();
        isValid = false;
      } else {
        medicalMobileNumberError = "";
        if (
          !state.medicalMobileNumber.startsWith("03") ||
          state.medicalMobileNumber.split("").length !== 11
        ) {
          medicalMobileNumberError =
            "Please enter a valid mobile number e.g 03001234567";
          document.getElementById("medicalMobileNumber").focus();
          isValid = false;
        } else {
          medicalMobileNumberError = "";
        }
      }
      if (!state.medicalRelationshipId) {
        medicalRelationshipIdError = "Please select relation.";
        document.getElementById("medicalRelationshipId").focus();
        isValid = false;
      } else {
        medicalRelationshipIdError = "";
      }
      if (!state.medicalName) {
        medicalNameError = "Please enter name.";
        document.getElementById("medicalName").focus();
        isValid = false;
      } else {
        medicalNameError = "";
      }
      if (!state.medicalCondition) {
        medicalNameError = "Please specify the medical condition.";
        document.getElementById("medicalCondition").focus();
        isValid = false;
      } else {
        medicalNameError = "";
      }
    } else {
      checkMedicalError = "";
    }
    if (state.appliedFor === 32) {
      state.gradeAcademicAlevelError = "";

      if (state.aLevelAcademicRecordsArray.length <= 0) {
        aLevelAcademicError = "Please add examination results.";
        document.getElementById("subjectAcademicAlevel").focus();
        isValid = false;
      } else {
        aLevelAcademicError = "";
      }

      if (!state.addressOfSchoolAlevel) {
        addressOfSchoolAlevelError = "Please enter the name of school.";
        document.getElementById("addressOfSchoolAlevel").focus();
        isValid = false;
      } else {
        addressOfSchoolAlevelError = "";
      }

      if (!state.nameOfSchoolAlevel) {
        nameOfSchoolAlevelError = "Please enter the name of school.";
        document.getElementById("nameOfSchoolAlevel").focus();
        isValid = false;
      } else {
        nameOfSchoolAlevelError = "";
      }

      if (!state.professionOfPersonAlevel) {
        professionOfPersonAlevelError = "Please enter the address.";
        document.getElementById("professionOfPersonAlevel").focus();
        isValid = false;
      } else {
        professionOfPersonAlevelError = "";
      }

      if (!state.addressOfPersonAlevel) {
        addressOfPersonAlevelError = "Please enter the address.";
        document.getElementById("addressOfPersonAlevel").focus();
        isValid = false;
      } else {
        addressOfPersonAlevelError = "";
      }

      if (!state.nameOfPersonAlevel) {
        nameOfPersonAlevelError = "Please enter the name.";
        document.getElementById("nameOfPersonAlevel").focus();
        isValid = false;
      } else {
        nameOfPersonAlevelError = "";
      }
    } else {
      if (
        state.academicSec2RecordsArray.length <= 0 &&
        state.academicsIsResultAwaitedSec2 == 0
      ) {
        academicSec2Error = "Please add subject and grade/marks.";
        document.getElementById("academicSubjectSec2").focus();
        isValid = false;
      } else {
        academicSec2Error = "";
      }

      // if (!state.academicsOverallMarksSec2) {
      //     academicsOverallMarksSec2Error = "Please enter overall grade/marks."
      //     document.getElementById("academicsOverallMarksSec2").focus();
      //     isValid = false;
      // } else {
      //     academicsOverallMarksSec2Error = ""
      // }

      if (
        !state.academicsIsResultAwaitedSec2 &&
        state.academicsIsResultAwaitedSec2 != 0
      ) {
        academicsIsResultAwaitedSec2Error =
          "Please select result awaited or not.";
        document.getElementById("academicsIsResultAwaitedSec2").focus();
        isValid = false;
      } else {
        academicsIsResultAwaitedSec2Error = "";
      }

      if (!state.academicsYearAwardedSec2) {
        academicsYearAwardedSec2Error = "Please enter the year.";
        document.getElementById("academicsYearAwardedSec2").focus();
        isValid = false;
      } else {
        academicsYearAwardedSec2Error = "";
      }

      if (!state.academicsQualificationSec2) {
        academicsQualificationSec2Error = "Please enter qualification.";
        document.getElementById("academicsQualificationSec2").focus();
        isValid = false;
      } else {
        academicsQualificationSec2Error = "";
      }

      if (!state.academicsNameOfInstitutionSec2) {
        academicsNameOfInstitutionSec2Error =
          "Please enter the name of institution.";
        document.getElementById("academicsNameOfInstitutionSec2").focus();
        isValid = false;
      } else {
        academicsNameOfInstitutionSec2Error = "";
      }

      if (!state.academicsNameOfAwardingBodySec2) {
        academicsNameOfAwardingBodySec2Error =
          "Please enter the name of awarding body .";
        document.getElementById("academicsNameOfAwardingBodySec2").focus();
        isValid = false;
      } else {
        academicsNameOfAwardingBodySec2Error = "";
      }

      if (
        state.academicRecordsArray.length <= 0 &&
        state.academicsIsResultAwaitedSec1 == 0
      ) {
        academicSec1Error = "Please add subject and grade/marks.";
        document.getElementById("academicSubjectSec1").focus();
        isValid = false;
      } else {
        academicSec1Error = "";
      }

      // if (!state.academicsOverallMarksSec1) {
      //     academicsOverallMarksSec1Error = "Please enter overall grade/marks."
      //     document.getElementById("academicsOverallMarksSec1").focus();
      //     isValid = false;
      // } else {
      //     academicsOverallMarksSec1Error = ""
      // }

      if (
        !state.academicsIsResultAwaitedSec1 &&
        state.academicsIsResultAwaitedSec1 != 0
      ) {
        academicsIsResultAwaitedSec1Error =
          "Please select result awaited or not.";
        document.getElementById("academicsIsResultAwaitedSec1").focus();
        isValid = false;
      } else {
        academicsIsResultAwaitedSec1Error = "";
      }

      if (!state.academicsYearAwardedSec1) {
        academicsYearAwardedSec1Error = "Please enter the year.";
        document.getElementById("academicsYearAwardedSec1").focus();
        isValid = false;
      } else {
        academicsYearAwardedSec1Error = "";
      }

      if (!state.academicsQualificationSec1) {
        academicsQualificationSec1Error = "Please enter qualification.";
        document.getElementById("academicsQualificationSec1").focus();
        isValid = false;
      } else {
        academicsQualificationSec1Error = "";
      }

      if (!state.academicsNameOfInstitutionSec1) {
        academicsNameOfInstitutionSec1Error =
          "Please enter name of institution.";
        document.getElementById("academicsNameOfInstitutionSec1").focus();
        isValid = false;
      } else {
        academicsNameOfInstitutionSec1Error = "";
      }

      if (!state.academicsNameOfAwardingBodySec1) {
        academicsNameOfAwardingBodySec1Error =
          "Please enter name of awarding body.";
        document.getElementById("academicsNameOfAwardingBodySec1").focus();
        isValid = false;
      } else {
        academicsNameOfAwardingBodySec1Error = "";
      }
    }
    if (!state.guardianInformationId) {
      guardianInformationIdError = "Please select guardian.";
      document.getElementById("guardianInformationId").focus();
      isValid = false;
    } else {
      guardianInformationIdError = "";
      if (state.guardianInformationId === 3) {
        if (!state.guardianOccupation) {
          guardianOccupationError = "Please select guardian occupation.";
          document.getElementById("guardianOccupation").focus();
          isValid = false;
        } else {
          guardianOccupationError = "";
        }
        /**
                regex = new RegExp(emailExp);
                if (!state.guardianEmail || !regex.test(state.guardianEmail)) {
                    guardianEmailError = "Please enter a valid email e.g name@domain.com"
                    document.getElementById("guardianEmail").focus();
                    isValid = false;
                } else {
                    guardianEmailError = ""
                }
                 */
        if (!state.guardianMobileNo) {
          guardianMobileNoError =
            "Please enter a valid mobile number e.g 03001234567";
          document.getElementById("guardianMobileNo").focus();
          isValid = false;
        } else {
          guardianMobileNoError = "";
          if (
            !state.guardianMobileNo.startsWith("03") ||
            state.guardianMobileNo.split("").length !== 11
          ) {
            guardianMobileNoError =
              "Please enter a valid mobile number e.g 03001234567";
            document.getElementById("guardianMobileNo").focus();
            isValid = false;
          } else {
            guardianMobileNoError = "";
          }
        }
        if (!state.guardianRelationId) {
          guardianRelationIdError = "Please select relationship";
          document.getElementById("guardianRelationId").focus();
          isValid = false;
        } else {
          guardianRelationIdError = "";
          if (
            state.guardianRelationId === 101 &&
            !state.guardianRelationOther
          ) {
            guardianRelationOtherError = "Please specify the relationship";
            document.getElementById("guardianRelationOther").focus();
            isValid = false;
          } else {
            guardianRelationOtherError = "";
          }
        }

        if (!state.guardianDocumentTypeId) {
          guardianDocumentTypeIdError = "Please select document type";
          document.getElementById("guardianDocumentTypeId").focus();
          isValid = false;
        } else {
          guardianDocumentTypeIdError = "";
          if (
            state.guardianDocumentTypeId === 1 &&
            !state.guardianCnic
          ) {
            guardianCnicError = "Please enter CNIC number.";
            document.getElementById("guardianCnic").focus();
            isValid = false;
          } else {
            guardianCnicError = "";
            if (
              state.guardianDocumentTypeId === 1 &&
              state.guardianCnic.split("").length !== 15
            ) {
              guardianCnicError =
                "Please enter valid CNIC number e.g xxxxx-xxxxxxx-x.";
              document.getElementById("guardianCnic").focus();
              isValid = false;
            } else {
              guardianCnicError = "";
            }
          }
          if (
            state.guardianDocumentTypeId === 2 &&
            !state.guardianPassport
          ) {
            guardianPassportError = "Please enter passport number.";
            document.getElementById("guardianPassport").focus();
            isValid = false;
          } else {
            guardianPassportError = "";
            if (
              state.guardianDocumentTypeId === 2 &&
              state.guardianPassport.split("").length !== 9
            ) {
              guardianPassportError =
                "Please enter valid passport number e.g xxxxxxxxx";
              document.getElementById("guardianPassport").focus();
              isValid = false;
            } else {
              guardianPassportError = "";
            }
          }
          if (
            state.guardianDocumentTypeId === 3 &&
            !state.guardianNicop
          ) {
            guardianNicopError = "Please enter NICOP number.";
            document.getElementById("guardianNicop").focus();
            isValid = false;
          } else {
            guardianNicopError = "";
            if (
              state.guardianDocumentTypeId === 3 &&
              state.guardianNicop.split("").length !== 15
            ) {
              guardianNicopError =
                "Please enter valid NICOP number e.g xxxxx-xxxxxxx-x.";
              document.getElementById("guardianNicop").focus();
              isValid = false;
            } else {
              guardianNicopError = "";
            }
          }
        }
        if (!state.guardianName) {
          guardianNameError = "Please enter name.";
          document.getElementById("guardianName").focus();
          isValid = false;
        } else {
          guardianNameError = "";
        }
        if (!state.guardianTitleId) {
          guardianTitleIdError = "Please select title.";
          document.getElementById("guardianTitleId").focus();
          isValid = false;
        } else {
          guardianTitleIdError = "";
        }
      }
    }
    if (state.motherTitleId !== 6) {
      if (!state.motherOccupation) {
        motherOccupationError = "Please select mother occupation.";
        document.getElementById("motherOccupation").focus();
        isValid = false;
      } else {
        motherOccupationError = "";
      }
      /**
                        regex = new RegExp(emailExp);
                        if (!state.motherEmail || !regex.test(state.motherEmail)) {
                            motherEmailError = "Please enter a valid email e.g name@domain.com"
                            document.getElementById("motherEmail").focus();
                            isValid = false;
                        } else {
                            motherEmailError = ""
                        }
             */
      if (!state.motherMobileNo) {
        motherMobileNoError =
          "Please enter a valid mobile number e.g 03001234567";
        document.getElementById("motherMobileNo").focus();
        isValid = false;
      } else {
        motherMobileNoError = "";
        if (
          !state.motherMobileNo.startsWith("03") ||
          state.motherMobileNo.split("").length !== 11
        ) {
          motherMobileNoError =
            "Please enter a valid mobile number e.g 03001234567";
          document.getElementById("motherMobileNo").focus();
          isValid = false;
        } else {
          motherMobileNoError = "";
        }
      }

      if (!state.motherDocumentTypeId) {
        motherDocumentTypeIdError = "Please select document type";
        document.getElementById("motherDocumentTypeId").focus();
        isValid = false;
      } else {
        motherDocumentTypeIdError = "";
        if (state.motherDocumentTypeId === 1 && !state.motherCnic) {
          motherCnicError = "Please enter CNIC number.";
          document.getElementById("motherCnic").focus();
          isValid = false;
        } else {
          motherCnicError = "";
          if (
            state.motherDocumentTypeId === 1 &&
            state.motherCnic.split("").length !== 15
          ) {
            motherCnicError =
              "Please enter valid CNIC number e.g xxxxx-xxxxxxx-x.";
            document.getElementById("motherCnic").focus();
            isValid = false;
          } else {
            motherCnicError = "";
          }
        }
        if (
          state.motherDocumentTypeId === 2 &&
          !state.motherPassport
        ) {
          motherPassportError = "Please enter passport number.";
          document.getElementById("motherPassport").focus();
          isValid = false;
        } else {
          motherPassportError = "";
          if (
            state.motherDocumentTypeId === 2 &&
            state.motherPassport.split("").length !== 9
          ) {
            motherPassportError =
              "Please enter valid passport number e.g xxxxxxxxx";
            document.getElementById("motherPassport").focus();
            isValid = false;
          } else {
            motherPassportError = "";
          }
        }
        if (state.motherDocumentTypeId === 3 && !state.motherNicop) {
          motherNicopError = "Please enter NICOP number.";
          document.getElementById("motherNicop").focus();
          isValid = false;
        } else {
          motherNicopError = "";
          if (
            state.motherDocumentTypeId === 3 &&
            state.motherNicop.split("").length !== 15
          ) {
            motherNicopError =
              "Please enter valid NICOP number e.g xxxxx-xxxxxxx-x.";
            document.getElementById("motherNicop").focus();
            isValid = false;
          } else {
            motherNicopError = "";
          }
        }
      }
    }

    if (!state.motherName) {
      motherNameError = "Please enter name.";
      document.getElementById("motherName").focus();
      isValid = false;
    } else {
      motherNameError = "";
    }

    if (!state.motherTitleId) {
      motherTitleIdError = "Please select title.";
      document.getElementById("motherTitleId").focus();
      isValid = false;
    } else {
      motherTitleIdError = "";
    }

    if (state.fatherTitleId !== 6) {
      if (!state.fatherOccupation) {
        fatherOccupationError = "Please select father occupation.";
        document.getElementById("fatherOccupation").focus();
        isValid = false;
      } else {
        fatherOccupationError = "";
      }
      /*
                        regex = new RegExp(emailExp);
                        if (!state.fatherEmail || !regex.test(state.fatherEmail)) {
                            fatherEmailError = "Please enter a valid email e.g name@domain.com"
                            document.getElementById("fatherEmail").focus();
                            isValid = false;
                        } else {
                            fatherEmailError = ""
                        }
            */
      if (!state.fatherMobileNo) {
        fatherMobileNoError =
          "Please enter a valid mobile number e.g 03001234567";
        document.getElementById("fatherMobileNo").focus();
        isValid = false;
      } else {
        fatherMobileNoError = "";
        if (
          !state.fatherMobileNo.startsWith("03") ||
          state.fatherMobileNo.split("").length !== 11
        ) {
          fatherMobileNoError =
            "Please enter a valid mobile number e.g 03001234567";
          document.getElementById("fatherMobileNo").focus();
          isValid = false;
        } else {
          fatherMobileNoError = "";
        }
      }

      if (!state.fatherDocumentTypeId) {
        fatherDocumentTypeIdError = "Please select document type";
        document.getElementById("fatherDocumentTypeId").focus();
        isValid = false;
      } else {
        fatherDocumentTypeIdError = "";
        if (state.fatherDocumentTypeId === 1 && !state.fatherCnic) {
          fatherCnicError = "Please enter CNIC number.";
          document.getElementById("fatherCnic").focus();
          isValid = false;
        } else {
          fatherCnicError = "";
          if (
            state.fatherDocumentTypeId === 1 &&
            state.fatherCnic.split("").length < 15
          ) {
            fatherCnicError =
              "Please enter valid CNIC number e.g xxxxx-xxxxxxx-x.";
            document.getElementById("fatherCnic").focus();
            isValid = false;
          } else {
            fatherCnicError = "";
          }
        }
        if (
          state.fatherDocumentTypeId === 2 &&
          !state.fatherPassport
        ) {
          fatherPassportError = "Please enter passport number.";
          document.getElementById("fatherPassport").focus();
          isValid = false;
        } else {
          fatherPassportError = "";
          if (
            state.fatherDocumentTypeId === 2 &&
            state.fatherPassport.split("").length !== 9
          ) {
            fatherPassportError =
              "Please enter valid passport number e.g xxxxxxxxx";
            document.getElementById("fatherPassport").focus();
            isValid = false;
          } else {
            fatherPassportError = "";
          }
        }
        if (state.fatherDocumentTypeId === 3 && !state.fatherNicop) {
          fatherNicopError = "Please enter NICOP number.";
          document.getElementById("fatherNicop").focus();
          isValid = false;
        } else {
          fatherNicopError = "";
          if (
            state.fatherDocumentTypeId === 3 &&
            state.fatherNicop.split("").length !== 15
          ) {
            fatherNicopError =
              "Please enter valid NICOP number e.g xxxxx-xxxxxxx-x.";
            document.getElementById("fatherNicop").focus();
            isValid = false;
          } else {
            fatherNicopError = "";
          }
        }
      }
    }

    if (!state.fatherName) {
      fatherNameError = "Please enter name.";
      document.getElementById("fatherName").focus();
      isValid = false;
    } else {
      fatherNameError = "";
    }

    if (!state.fatherTitleId) {
      fatherTitleIdError = "Please select title.";
      document.getElementById("fatherTitleId").focus();
      isValid = false;
    } else {
      fatherTitleIdError = "";
    }
    if (state.mailingAddressId === 2) {
      if (!state.presentPostalCode) {
        presentPostalCodeError = "Please enter postal code.";
        document.getElementById("presentPostalCode").focus();
        isValid = false;
      } else {
        presentPostalCodeError = "";
      }
      if (!state.presentCityId) {
        presentCityIdError = "Please select city.";
        document.getElementById("presentCityId").focus();
        isValid = false;
      } else {
        presentCityIdError = "";
      }

      if (!state.presentProvinceId) {
        presentProvinceIdError = "Please select province.";
        document.getElementById("presentProvinceId").focus();
        isValid = false;
      } else {
        presentProvinceIdError = "";
      }

      if (!state.presentCountryId) {
        presentCountryIdError = "Please select country.";
        document.getElementById("presentCountryId").focus();
        isValid = false;
      } else {
        presentCountryIdError = "";
      }

      if (!state.presentAddress) {
        presentAddressError = "Please enter address.";
        document.getElementById("presentAddress").focus();
        isValid = false;
      } else {
        presentAddressError = "";
      }
    }

    if (!state.mailingAddressId) {
      mailingAddressIdError = "Please select Mailing address type.";
      document.getElementById("mailingAddressId").focus();
      isValid = false;
    } else {
      mailingAddressIdError = "";
    }

    if (!state.permanentPostalCode) {
      permanentPostalCodeError = "Please enter postal code.";
      document.getElementById("permanentPostalCode").focus();
      isValid = false;
    } else {
      permanentPostalCodeError = "";
    }
    if (!state.permanentCityId) {
      permanentCityIdError = "Please select city.";
      document.getElementById("permanentCityId").focus();
      isValid = false;
    } else {
      permanentCityIdError = "";
    }

    if (!state.permanentProvinceId) {
      permanentProvinceIdError = "Please select province.";
      document.getElementById("permanentProvinceId").focus();
      isValid = false;
    } else {
      permanentProvinceIdError = "";
    }

    if (!state.permanentCountryId) {
      permanentCountryIdError = "Please select country.";
      document.getElementById("permanentCountryId").focus();
      isValid = false;
    } else {
      permanentCountryIdError = "";
    }

    if (!state.permanentAddress) {
      permanentAddressError = "Please enter address.";
      document.getElementById("permanentAddress").focus();
      document.body.scrollTop = 10;
      isValid = false;
    } else {
      permanentAddressError = "";
    }

    /*
        if (!state.userBloodGroupId) {
            userBloodGroupIdError = "Please select blood group."
            document.getElementById("userBloodGroupId").focus();
            document.body.scrollTop = 0;
            isValid = false;
        } else {
            userBloodGroupIdError = "";
        }*/

    if (!state.userMaterialStatusId) {
      userMaterialStatusIdError = "Please select marital status.";
      document.getElementById("userMaterialStatusId").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      userMaterialStatusIdError = "";
    }

    if (!state.userDocumentTypeId) {
      userDocumentTypeIdError = "Please select document type";
      document.getElementById("userDocumentTypeId").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      userDocumentTypeIdError = "";
      if (
        state.userDocumentTypeId === 1 &&
        !state.userNicopCnicBform
      ) {
        userNicopCnicBformError = "Please enter CNIC / B Form number.";
        document.getElementById("userNicopCnicBform").focus();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        isValid = false;
      } else {
        userNicopCnicBformError = "";
        if (
          (state.userDocumentTypeId === 1 ||
            state.userDocumentTypeId === 4) &&
          state.userNicopCnicBform.split("").length !== 15
        ) {
          userNicopCnicBformError =
            "Please enter valid CNIC / B Form number e.g xxxxx-xxxxxxx-x.";
          document.getElementById("userNicopCnicBform").focus();
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          isValid = false;
        } else {
          userNicopCnicBformError = "";
        }
      }
      if (state.userDocumentTypeId === 2 && !state.userPassport) {
        userPassportError = "Please enter passport number.";
        document.getElementById("userPassport").focus();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        isValid = false;
      } else {
        userPassportError = "";
        if (
          state.userDocumentTypeId === 2 &&
          state.userPassport.split("").length !== 9
        ) {
          userPassportError =
            "Please enter valid passport number e.g xxxxxxxxx";
          document.getElementById("userPassport").focus();
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          isValid = false;
        } else {
          userPassportError = "";
        }
      }
      if (state.userDocumentTypeId === 3 && !state.userNicop) {
        userNicopError = "Please enter NICOP number.";
        document.getElementById("userNicop").focus();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        isValid = false;
      } else {
        userNicopError = "";
        if (
          state.userDocumentTypeId === 3 &&
          state.userNicop.split("").length !== 15
        ) {
          userNicopError =
            "Please enter valid NICOP number e.g xxxxx-xxxxxxx-x.";
          document.getElementById("userNicop").focus();
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          isValid = false;
        } else {
          userNicopError = "";
        }
      }
    }

    if (!state.nationalityId) {
      nationalityIdError = "Please select nationality";
      document.getElementById("nationalityId").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      nationalityIdError = "";
    }

    if (!state.mobileNo) {
      mobileNoError = "Please enter mobile number";
      document.getElementById("mobileNo").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      mobileNoError = "";
      if (
        !state.mobileNo.startsWith("03") ||
        state.mobileNo.split("").length !== 11
      ) {
        mobileNoError = "Please enter a valid mobile number e.g 03001234567";
        document.getElementById("mobileNo").focus();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        isValid = false;
      } else {
        mobileNoError = "";
      }
    }

    regex = new RegExp(emailExp);
    if (!state.email || !regex.test(state.email)) {
      emailError = "Please enter a valid email e.g name@domain.com";
      document.getElementById("email").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      emailError = "";
    }

    if (!state.genderId) {
      genderIdError = "Please select gender";
      document.getElementById("genderId").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      genderIdError = "";
    }

    if (!state.dateOfBirth) {
      dateOfBirthError = "Please select date of birth";
      document.getElementById("dateOfBirth").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      dateOfBirthError = "";
    }

    if (!state.lastName) {
      lastNameError = "Please enter last name";
      document.getElementById("lastName").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      lastNameError = "";
    }

    if (!state.firstName) {
      firstNameError = "Please enter first name";
      document.getElementById("firstName").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      firstNameError = "";
    }

    if (!state.displayName) {
      displayNameError = "Please enter name as per Passport/CNIC";
      document.getElementById("displayName").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      displayNameError = "";
    }

    if (!state.appliedFor) {
      appliedForError = "Please select programme";
      document.getElementById("appliedFor").focus();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      isValid = false;
    } else {
      appliedForError = "";
      let isInactiveDegree = state.degreeData.findIndex(
        (item) => item.id == state.appliedFor && item.isActive == 0
      );
      if (isInactiveDegree >= 0) {
        appliedForError =
          "Your selected programme is now closed, please contact admin & support team";
        alert(appliedForError);
        document.getElementById("appliedFor").focus();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        isValid = false;
      } else {
        if (state.appliedFor === 8 && !state.chessSubDegree) {
          chessSubDegreeError = "Please select degree";
          document.getElementById("chessSubDegree").focus();
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          isValid = false;
        } else {
          chessSubDegreeError = "";
        }

        if (state.appliedFor === 32 && !state.yearAlevel) {
          yearAlevelError = "Please select A level year";
          document.getElementById("yearAlevel").focus();
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          isValid = false;
        } else {
          yearAlevelError = "";
        }
      }
    }

    let selectedCourseIdsError = "";
    if (state.offeredCoursesData && state.offeredCoursesData.length > 0) {
      const count = (state.selectedCourseIds || []).length;
      if (count < 3) {
        selectedCourseIdsError = "Please select at least 3 subjects.";
        isValid = false;
      } else if (count > 6) {
        selectedCourseIdsError = "You can select a maximum of 6 subjects.";
        isValid = false;
      }
    }

    updateState({
      selectedCourseIdsError,
      iAgreeCheckError,
      reasonsError,
      hearFromError,
      hearMagzineNameError,
      hearOtherSourceError,
      checkMedicalError,
      medicalMobileNumberError,
      medicalRelationshipIdError,
      medicalNameError,
      medicalConditionError,
      academicSec2Error,
      academicsOverallMarksSec2Error,
      academicsIsResultAwaitedSec2Error,
      academicsYearAwardedSec2Error,
      academicsQualificationSec2Error,
      academicsNameOfInstitutionSec2Error,
      academicsNameOfAwardingBodySec2Error,
      academicSec1Error,
      academicsOverallMarksSec1Error,
      academicsIsResultAwaitedSec1Error,
      academicsYearAwardedSec1Error,
      academicsQualificationSec1Error,
      academicsNameOfInstitutionSec1Error,
      academicsNameOfAwardingBodySec1Error,
      guardianInformationIdError,
      guardianOccupationError,
      guardianEmailError,
      guardianMobileNoError,
      guardianRelationIdError,
      guardianRelationOtherError,
      guardianDocumentTypeIdError,
      guardianCnicError,
      guardianPassportError,
      guardianNicopError,
      guardianNameError,
      guardianTitleIdError,
      motherOccupationError,
      motherEmailError,
      motherMobileNoError,
      motherDocumentTypeIdError,
      motherCnicError,
      motherPassportError,
      motherNicopError,
      motherNameError,
      motherTitleIdError,
      fatherOccupationError,
      fatherEmailError,
      fatherMobileNoError,
      fatherDocumentTypeIdError,
      fatherCnicError,
      fatherPassportError,
      fatherNicopError,
      fatherNameError,
      fatherTitleIdError,
      mailingAddressIdError,
      presentAddressError,
      presentCityIdError,
      presentCountryIdError,
      presentPostalCodeError,
      presentProvinceIdError,
      permanentAddressError,
      permanentCityIdError,
      permanentCountryIdError,
      permanentPostalCodeError,
      permanentProvinceIdError,
      userMaterialStatusIdError,
      userBloodGroupIdError,
      userDocumentTypeIdError,
      userNicopCnicBformError,
      userPassportError,
      userNicopError,
      nationalityIdError,
      mobileNoError,
      emailError,
      genderIdError,
      dateOfBirthError,
      firstNameError,
      lastNameError,
      displayNameError,
      categoryError: "",
      appliedForError,
      yearAlevelError,
      chessSubDegreeError,
      aLevelAcademicError,
      nameOfSchoolAlevelError,
      addressOfSchoolAlevelError,
      nameOfPersonAlevelError,
      addressOfPersonAlevelError,
      professionOfPersonAlevelError,
      checkSubjectsError,
      checkSubjectsGroup19Error,
    });

    return isValid;
  };

  const handleOnClick = () => {
    if (isFormValid()) {
      document.getElementById("submit-button").click();
    }
  };

  const onFormSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    updateState({
      isLoading: true,
    });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplication`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            window.localStorage.setItem("isSaved", 1);
            window.localStorage.setItem(
              "applicationId",
              json.DATA[0].ApplicationId
            );
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            handleSuccessDialog();
          } else {
            alert(json.USER_MESSAGE + "\n" + json.SYSTEM_MESSAGE);
          }
          console.log(json);
        },
        (error) => {
          if (error.status == 401) {
            updateState({
              isLoginMenu: true,
              isReload: false,
            });
          } else {
            console.log(error);
            alert("Failed to Save ! Please try Again later.");
          }
        }
      );
    updateState({
      isLoading: false,
    });
  };

  const setData = (data = {}) => {
    const nationalityObject = state.nationalityData.find(
      (item) => item.ID === data.nationalityId
    );
    const permanentCountriesObject = state.countriesData.find(
      (item) => item.ID === data.permanentCountryId
    );
    const presentCountriesObject = state.countriesData.find(
      (item) => item.ID === data.mailingCountryId
    );
    const otherQua = data.otherQualifications || [];
    const academicSec1 = data.graduationAcademicsSubjectsInter || [];
    const academicSec2 = data.graduationAcademicsSubjectsBachelors || [];
    const extraActivity = data.coCurricularActivities || [];
    const workExperience = data.workExperience || [];
    const uclRelation = data.relativesStatus || [];
    const olevelAcademics = data.alevelAcademicsSubjects || [];
    const takenSubjects = data.alevelTakenSubjects || [];
    let otherQualificationArr = [];
    let sec1Record = [];
    let sec2Record = [];
    let activityRecord = [];
    let workRecord = [];
    let uclRelationRecord = [];
    let olevelAcademicsRecord = [];
    let takenSubjectsRecord = [];
    let takenSubjectsGroup19Record = [];

    if (otherQua.length > 0) {
      for (let i = 0; i < otherQua.length; i++) {
        otherQualificationArr.push({
          nameAward: otherQua[i].awardingBody,
          nameInstitution: otherQua[i].institution,
          qualification: otherQua[i].qualification,
        });
      }
    }

    if (academicSec1.length > 0) {
      for (let i = 0; i < academicSec1.length; i++) {
        sec1Record.push({
          subject: academicSec1[i].subject,
          gradeMarks: academicSec1[i].grade || academicSec1[i].marks,
        });
      }
    }

    if (academicSec2.length > 0) {
      for (let i = 0; i < academicSec2.length; i++) {
        sec2Record.push({
          subject: academicSec2[i].subject,
          gradeMarks: academicSec2[i].grade || academicSec2[i].marks,
        });
      }
    }

    if (extraActivity.length > 0) {
      for (let i = 0; i < extraActivity.length; i++) {
        activityRecord.push({
          institution: extraActivity[i].institution,
          tenure: extraActivity[i].tenureMonths,
          activity: extraActivity[i].activity,
          position: extraActivity[i].position,
          nature: extraActivity[i].natureOfPositionHeld,
        });
      }
    }

    if (workExperience.length > 0) {
      for (let i = 0; i < workExperience.length; i++) {
        workRecord.push({
          organization: workExperience[i].organization,
          tenure: workExperience[i].tenureMonths,
          activity: workExperience[i].activity,
          position: workExperience[i].position,
          nature: workExperience[i].natureOfPositionHeld,
        });
      }
    }

    if (uclRelation.length > 0) {
      for (let i = 0; i < uclRelation.length; i++) {
        uclRelationRecord.push({
          institution: uclRelation[i].institutionLabel,
          relationship: uclRelation[i].relationship,
          status: uclRelation[i].roleLabel,
          designation: uclRelation[i].designation,
          name2: uclRelation[i].name,
          department: uclRelation[i].department,
          program: uclRelation[i].programme,
          year: uclRelation[i].graduationYear || "",
          uclRoleId: uclRelation[i].roleId,
          uclInstitutionId: uclRelation[i].institutionId,
        });
      }
    }

    if (olevelAcademics.length > 0) {
      for (let i = 0; i < olevelAcademics.length; i++) {
        olevelAcademicsRecord.push({
          subject: olevelAcademics[i].subject,
          exam: olevelAcademics[i].examTitle,
          board: olevelAcademics[i].board,
          session: olevelAcademics[i].session,
          grade: olevelAcademics[i].grade,
        });
      }
    }

    if (takenSubjects.length > 0) {
      updateState({
        switchSateGroupId: takenSubjects[0].aLevelTakenSubjectGroupId,
      });

      for (let i = 0; i < takenSubjects.length; i++) {
        if (takenSubjects[i].aLevelTakenSubjectGroupId == 21) {
          takenSubjectsGroup19Record.push({
            id: takenSubjects[i].subjectId,
            checked: takenSubjects[i].subjectId,
            label: takenSubjects[i].subjectLabel,
            grpId: takenSubjects[i].aLevelTakenSubjectGroupId,
          });
        } else {
          takenSubjectsRecord.push({
            id: takenSubjects[i].subjectId,
            checked: takenSubjects[i].subjectId,
            label: takenSubjects[i].subjectLabel,
            grpId: takenSubjects[i].aLevelTakenSubjectGroupId,
          });
        }
      }
    }

    const dob = data.dateOfBirthWithOutConversion
      ? new Date(data.dateOfBirthWithOutConversion)
      : new Date();

    updateState({
      appliedForDefault: data.degreeId || "",
      appliedFor: data.degreeId || "",
      category: data.isTransferCandidate || 0,
      yearAlevel: data.alevelAdmissionYear || "",
      chessSubDegree: data.chessDegreeTransferId || "",
      firstName: data.firstName || "",
      middleName: data.middleName || "",
      lastName: data.lastName || "",
      displayName: data.displayName || "",
      dateOfBirth: dob,
      genderId: data.genderId || "",
      nationalityId: data.nationalityId || "",
      nationalityIdObject: nationalityObject || {},
      mobileNo: data.mobileNo || "",
      userDocumentTypeId: data.studentIdentity || "",
      userNicopCnicBform: data.cnicBform || "",
      userPassport: data.passportNumber || "",
      userBform: data.cnicBform || "",
      userNicop: data.nicopNumber || "",
      userMaterialStatusId: data.maritalStatusId || "",
      userBloodGroupId: data.bloodGroupId || "",

      mailingAddressId: data.mailingAddressTypeId || "",
      presentAddress: data.mailingAddress || "",
      presentPostalCode: data.mailingPostalCode || "",
      presentCountryId: data.mailingCountryId || "",
      presentCountryIdObject: presentCountriesObject || {},

      permanentAddress: data.permanentAddress || "",
      permanentPostalCode: data.permanentPostalCode || "",
      permanentCountryId: data.permanentCountryId || "",
      permanentCountryIdObject: permanentCountriesObject || {},

      fatherTitleId: data.fatherTitleId || "",
      fatherDocumentTypeId: data.fatherIdentityType || "",
      fatherCnic: data.fatherIdentityType === 1 ? data.fatherCnicPassport : "",
      fatherPassport:
        data.fatherIdentityType === 2 ? data.fatherCnicPassport : "",
      fatherNicop: data.fatherIdentityType === 3 ? data.fatherCnicPassport : "",
      fatherOccupation: data.fatherOccupationId || "",
      fatherMobileNo: data.fatherMobileNo || "",
      fatherName: data.fatherName || "",
      fatherEmail: data.fatherEmail || "",

      motherTitleId: data.motherTitleId || "",
      motherDocumentTypeId: data.motherIdentityType || "",
      motherCnic: data.motherIdentityType === 1 ? data.motherCnicPassport : "",
      motherPassport:
        data.motherIdentityType === 2 ? data.motherCnicPassport : "",
      motherNicop: data.motherIdentityType === 3 ? data.motherCnicPassport : "",
      motherOccupation: data.motherOccupationId || "",
      motherMobileNo: data.motherMobileNo || "",
      motherName: data.motherName || "",
      motherEmail: data.motherEmail || "",

      guardianInformationId: data.guardianId || "",
      guardianDocumentTypeId: data.guardianIdentity || "",
      guardianTitleId: data.guardianTitleId || "",
      guardianCnic:
        data.guardianIdentity === 1 ? data.guardianCnicPassport : "",
      guardianPassport:
        data.guardianIdentity === 2 ? data.guardianCnicPassport : "",
      guardianNicop:
        data.guardianIdentity === 3 ? data.guardianCnicPassport : "",
      guardianOccupation: data.guardianOccupationId || "",
      guardianMobileNo: data.guardianMobileNo || "",
      guardianName: data.guardianName || "",
      guardianEmail: data.guardianEmail || "",
      guardianRelationId: data.guardianRelationWithStudentId || "",
      guardianRelationOther: "",

      nameOfPersonAlevel: data.financialName || "",
      addressOfPersonAlevel: data.financialAddress || "",
      professionOfPersonAlevel: data.financialProfession || "",

      nameOfSchoolAlevel: data.olevelSchoolName || "",
      addressOfSchoolAlevel: data.olevelSchoolAddress || "",
      aLevelAcademicRecordsArray: olevelAcademicsRecord,

      academicsNameOfAwardingBodySec1: data.interAwardingBody || "",
      academicsNameOfInstitutionSec1: data.interInstitution || "",
      academicsQualificationSec1: data.interQualification || "",
      academicsYearAwardedSec1: data.interYearAwarded || "",
      academicsIsResultAwaitedSec1: data.interIsResultAwaiting || 0,
      academicsOverallMarksSec1: data.interMarks || "",
      academicRecordsArray: sec1Record,

      academicsNameOfAwardingBodySec2: data.bachelorsAwardingBody || "",
      academicsNameOfInstitutionSec2: data.bachelorsInstitution || "",
      academicsQualificationSec2: data.bachelorsQualification || "",
      academicsYearAwardedSec2: data.bachelorsYearAwarded || "",
      academicsIsResultAwaitedSec2: data.bachelorsIsResultAwaiting || 0,
      academicsOverallMarksSec2: data.bachelorsGrade || "",
      academicSec2RecordsArray: sec2Record,

      qualificationRecordsArray: otherQualificationArr,

      activityRecordsArray: activityRecord,

      checkSubjects: takenSubjectsRecord,

      checkSubjectsGroup19: takenSubjectsGroup19Record,
      workRecordsArray: workRecord,

      uclRelationRecordsArray: uclRelationRecord,

      checkMedical: data.isAnyMedicalCondition || 0,
      medicalCondition: data.medicalCondition || "",
      medicalName: data.emergencyContactPersonName || "",
      medicalRelationshipId: data.emergencyContactRelationshipId || "",
      medicalMobileNumber: data.emergencyContactNumber || "",

      hearFrom: data.uclSourceId || "",
      hearMagzineName: data.uclSourceName || "",
      hearOtherSource: data.uclOtherSource || "",

      reasons: data.reasonsForApplying || "",

      data,
    });
    if (data.degreeId) {
      getOfferedCoursesData(data.degreeId);
    }
    console.log(state.appliedForDefault, "kk");
  };

  const getData = async () => {
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/academics/C01AdmissionsProspectApplicationView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            if (json.DATA) {
              if (json.DATA.length > 0) {
                getProvinceData(
                  json.DATA[0].mailingCountryId,
                  "present",
                  json.DATA[0].mailingProvinceId
                );
                getProvinceData(
                  json.DATA[0].permanentCountryId,
                  "permanent",
                  json.DATA[0].permanentProvinceId
                );
                getCitiesData(
                  json.DATA[0].mailingProvinceId,
                  "present",
                  json.DATA[0].mailingCityId
                );
                getCitiesData(
                  json.DATA[0].permanentProvinceId,
                  "permanent",
                  json.DATA[0].permanentCityId
                );
                setData(json.DATA[0]);
              }
            }
          } else {
            alert(json.USER_MESSAGE + "\n" + json.SYSTEM_MESSAGE);
          }
          console.log(json);
        },
        (error) => {
          if (error.status == 401) {
            updateState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            alert("Failed to fetch, Please try again later.");
            console.log(error);
          }
        }
      );
  };

  const handleClose = () => {
    updateState({
      openReview: false,
    });
  };



  let fatherDBCnic = "";
  switch (state.fatherDocumentTypeId) {
    case 1:
      fatherDBCnic = state.fatherCnic;
      break;
    case 2:
      fatherDBCnic = state.fatherPassport;
      break;
    case 3:
      fatherDBCnic = state.fatherNicop;
      break;
    default:
      break;
  }
  let motherDBCnic = "";
  switch (state.motherDocumentTypeId) {
    case 1:
      motherDBCnic = state.motherCnic;
      break;
    case 2:
      motherDBCnic = state.motherPassport;
      break;
    case 3:
      motherDBCnic = state.motherNicop;
      break;
    default:
      break;
  }
  let guardianDBCnic = "";
  switch (state.guardianDocumentTypeId) {
    case 1:
      guardianDBCnic = state.guardianCnic;
      break;
    case 2:
      guardianDBCnic = state.guardianPassport;
      break;
    case 3:
      guardianDBCnic = state.guardianNicop;
      break;
    default:
      break;
  }
  const userDob = format(
    state.dateOfBirth || new Date("2000-01-01"),
    "dd/MM/yyyy"
  );
  return (
    <Fragment>
      <LoginMenu
        reload={state.isReload}
        open={state.isLoginMenu}
        handleClose={() => updateState({ isLoginMenu: false })}
      />
      <Dialog
        open={state.loadingData}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogContent
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
          <span
            style={{
              marginTop: 15,
              marginBottom: 15,
            }}
          >
            Please Wait...
          </span>
        </DialogContent>
      </Dialog>
      <Dialog
        open={state.successDialog}
        onClose={handleSuccessDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Success"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your admission application is now complete. Please click OK to
            upload the required documents.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary">
            <Link
              style={{ textDecoration: "none" }}
              to="/dashboard/documents"
            >
              OK
            </Link>
          </Button>
        </DialogActions>
      </Dialog>
      <Grid container component="main" className={classes.root}>
        <Typography
          style={{
            color: "#1d5f98",
            fontWeight: 600,
            borderBottom: "1px solid #d2d2d2",
            width: "98%",
            marginBottom: 25,
            fontSize: 20,
          }}
          variant="h5"
        >
          Admission Application
        </Typography>
        <Divider
          style={{
            backgroundColor: "rgb(58, 127, 187)",
            opacity: "0.3",
          }}
        />
        <Grid
          container
          spacing={2}
          style={{ marginLeft: 5, marginRight: 10 }}
        >
          <Grid xs={12}>
            <span className={classes.sectionTitle}>Course Applied For</span>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl
              error={!!state.appliedForError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="appliedFor">Programme</InputLabel>
              <Select
                name="appliedFor"
                id="appliedFor"
                value={state.appliedFor}
                onChange={handleChange}
              >
                {state.degreeData.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      disabled={!item.id || item.isActive == 0}
                      value={item.id}
                    >
                      {item.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          {state.appliedFor === 32 && (
            <Grid item xs={12} sm={6}>
              <FormControl
                error={!!state.yearAlevelError}
                className={classes.formControl}
              >
                <InputLabel htmlFor="yearAlevel">
                  Select Year for ‘A’ Level Admission
                </InputLabel>
                <Select
                  value={state.yearAlevel}
                  onChange={handleChange}
                  name="yearAlevel"
                  id="yearAlevel"
                >
                  <MenuItem value={1}>Year 1</MenuItem>
                  <MenuItem value={2}>Year 2</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}

          {state.appliedFor === 8 && (
            <Grid item xs={12} sm={6}>
              <FormControl
                error={!!state.chessSubDegreeError}
                className={classes.formControl}
              >
                <InputLabel htmlFor="chessSubDegree">
                  Specify the degree to transfer after completing the CHESS
                </InputLabel>
                <Select
                  onChange={handleChange}
                  value={state.chessSubDegree}
                  name="chessSubDegree"
                  id="chessSubDegree"
                >
                  {state.chessSubDegreeData.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item.id}>
                        {item.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          )}

          <Grid style={{ marginBottom: 10 }} item xs={12} sm={6}>
            <FormControl
              error={!!state.categoryError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="category">Category</InputLabel>
              <Select
                value={state.category}
                onChange={handleChange}
                name="category"
                id="category"
              >
                <MenuItem value={0}>New Admission</MenuItem>
                <MenuItem value={1}>Transfer</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid xs={12}>
            <span className={classes.sectionTitle}>Personal Information</span>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              id="firstName"
              name="firstName"
              label="First Name"
              required
              fullWidth
              onKeyDown={StopEnter}
              onChange={handleChange}
              value={state.firstName}
              error={!!state.firstNameError}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              id="middleName"
              name="middleName"
              label="Middle Name"
              fullWidth
              onKeyDown={StopEnter}
              onChange={handleChange}
              value={state.middleName}
              error={!!state.middleNameError}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              id="lastName"
              name="lastName"
              label="Last Name"
              required
              fullWidth
              onKeyDown={StopEnter}
              onChange={handleChange}
              value={state.lastName}
              error={!!state.lastNameError}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <TextField
              id="displayName"
              name="displayName"
              label="Name as per Passport/CNIC"
              required
              fullWidth
              onKeyDown={StopEnter}
              onChange={handleChange}
              value={state.displayName}
              error={!!state.displayNameError}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePicker
              format="dd-MMM-yyyy"
              views={["year", "month", "day"]}
              openTo={"year"}
              label="Date of Birth as per Passport/CNIC"
              value={state.dateOfBirth}
              onChange={handleDateChange}
              disableFuture
              slotProps={{
                textField: {
                  required: true,
                  fullWidth: true,
                  id: "dateOfBirth",
                  name: "dateOfBirth",
                  error: !!state.dateOfBirthError,
                  helperText: state.dateOfBirthError
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <FormControl
              error={!!state.genderIdError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="genderId">Gender</InputLabel>
              <Select
                label="Select Gender"
                name="genderId"
                id="genderId"
                fullWidth
                required
                onChange={handleChange}
                value={state.genderId}
                inputProps={{
                  name: "genderId",
                  id: "genderId",
                  ref: selectRef,
                }}
              >
                {state.genderData.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField
              onKeyDown={StopEnter}
              id="email"
              name="email"
              label="Email"
              type="email"
              onChange={handleChange}
              placeholder="e.g name@domain.com"
              helperText={state.email ? state.emailError : ""}
              value={state.email}
              error={!!state.emailError}
              disabled
              required
              fullWidth
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              id="mobileNo"
              name="mobileNo"
              label="Mobile No"
              type="text"
              inputProps={{
                maxLength: 11,
              }}
              onChange={handleChange}
              placeholder="e.g 03XXXXXXXXX"
              helperText={state.mobileNo ? state.mobileNoError : ""}
              value={state.mobileNo}
              error={!!state.mobileNoError}
              required
              fullWidth
              onKeyDown={StopEnter}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              id="nationalityId"
              getOptionLabel={(option) => option.Label}
              fullWidth
              options={state.nationalityData}
              onChange={handleAutoComplete("nationalityId")}
              value={state.nationalityIdObject}
              renderInput={(params) => (
                <TextField
                  label="Nationality"
                  error={!!state.nationalityIdError}
                  {...params}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl
              error={!!state.userDocumentTypeIdError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="userDocumentTypeId">
                Identity Document Type{" "}
              </InputLabel>
              <Select
                fullWidth
                id="userDocumentTypeId"
                value={state.userDocumentTypeId}
                onChange={handleChange}
                name="userDocumentTypeId"
                required
                inputProps={{
                  name: "userDocumentTypeId",
                  id: "userDocumentTypeId",
                }}
              >
                {state.documentTypeData.map((item) => {
                  return (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.Label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          {(state.userDocumentTypeId === 1 ||
            state.userDocumentTypeId === 4) && (
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  id="userNicopCnicBform"
                  name="userNicopCnicBform"
                  label="CNIC/B-Form"
                  type="text"
                  required
                  placeholder="e.g xxxxx-xxxxxxx-x"
                  helperText={
                    state.userNicopCnicBform
                      ? state.userNicopCnicBformError
                      : ""
                  }
                  onChange={cnicCheckHandling}
                  value={state.userNicopCnicBform}
                  error={!!state.userNicopCnicBformError}
                  onKeyDown={StopEnter}
                />
              </Grid>
            )}

          {state.userDocumentTypeId === 2 && (
            <Grid item xs={6}>
              <TextField
                onKeyDown={StopEnter}
                onChange={handleChange}
                value={state.userPassport}
                error={!!state.userPassportError}
                placeholder="e.g xxxxxxxxx"
                helperText={
                  state.userPassport ? state.userPassportError : ""
                }
                type="text"
                name="userPassport"
                id="userPassport"
                label="Passport#"
                inputProps={{
                  maxLength: 9,
                }}
                fullWidth
              />
            </Grid>
          )}

          {state.userDocumentTypeId === 3 && (
            <Grid item xs={12} sm={6}>
              <TextField
                onKeyDown={StopEnter}
                onChange={cnicCheckHandling}
                value={state.userNicop}
                error={!!state.userNicopError}
                placeholder="e.g xxxxx-xxxxxxx-x"
                helperText={
                  state.userNicop ? state.userNicopError : ""
                }
                name="userNicop"
                id="userNicop"
                label="NICOP"
                type="text"
                required
                fullWidth
              />
            </Grid>
          )}
          <Grid item xs={6}>
            <FormControl
              error={!!state.userMaterialStatusIdError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="userMaterialStatusId">
                Marital Status
              </InputLabel>
              <Select
                name="userMaterialStatusId"
                id="userMaterialStatusId"
                fullWidth
                required
                onChange={handleChange}
                value={state.userMaterialStatusId}
                inputProps={{
                  name: "userMaterialStatusId",
                  id: "userMaterialStatusId",
                }}
              >
                {state.materialStatusData.map((item) => {
                  return (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.Label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl
              error={!!state.userBloodGroupIdError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="userBloodGroupId">Blood Group</InputLabel>
              <Select
                name="userBloodGroupId"
                id="userBloodGroupId"
                fullWidth
                required
                onChange={handleChange}
                value={state.userBloodGroupId}
                inputProps={{
                  name: "userBloodGroupId",
                  id: "userBloodGroupId",
                }}
              >
                {state.bloodGroupData.map((item) => {
                  return (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.Label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            xs={12}
            style={{ paddingBottom: 20, paddingTop: 20, marginLeft: 10 }}
          >
            <span style={{ fontSize: 16 }} className={classes.sectionTitle}>
              Permanent Address
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: "-20px",
            }}
          >
            <TextField
              id="permanentAddress"
              name="permanentAddress"
              label="Address"
              value={state.permanentAddress}
              error={!!state.permanentAddressError}
              onChange={handleChange}
              type="text"
              onKeyDown={keyPress}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: "-20px",
            }}
          >
            <Autocomplete
              id="permanentCountryId"
              getOptionLabel={(option) => option.Label}
              fullWidth
              options={state.countriesData}
              onChange={handleAutoComplete("permanentCountryId")}
              value={state.permanentCountryIdObject}
              renderInput={(params) => (
                <TextField
                  label="Country"
                  error={!!state.permanentCountryIdError}
                  {...params}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="permanentProvinceId"
              getOptionLabel={(option) => option.Label}
              fullWidth
              options={state.permanentProvinceData}
              onChange={handleAutoComplete("permanentProvinceId")}
              value={state.permanentProvinceIdObject}
              renderInput={(params) => (
                <TextField
                  label="Province"
                  error={!!state.permanentProvinceIdError}
                  {...params}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="permanentCityId"
              getOptionLabel={(option) => option.Label}
              fullWidth
              options={state.permanentCitiesData}
              onChange={handleAutoComplete("permanentCityId")}
              value={state.permanentCityIdObject}
              renderInput={(params) => (
                <TextField
                  label="City"
                  error={!!state.permanentCityIdError}
                  {...params}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="permanentPostalCode"
              name="permanentPostalCode"
              label="Postal Code"
              value={state.permanentPostalCode}
              error={!!state.permanentPostalCodeError}
              onChange={handleChange}
              type="text"
              onKeyDown={keyPress}
              fullWidth
            />
          </Grid>

          <Grid
            xs={12}
            style={{ paddingBottom: 20, paddingTop: 20, marginLeft: 10 }}
          >
            <span style={{ fontSize: 16 }} className={classes.sectionTitle}>
              Current Mailing/ Present Address
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              marginTop: "-20px",
            }}
          >
            <FormControl
              error={!!state.mailingAddressIdError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="mailingAddressId">
                Mailing Address
              </InputLabel>
              <Select
                name="mailingAddressId"
                id="mailingAddressId"
                value={state.mailingAddressId}
                onChange={handleChange}
                fullWidth
                required
                inputProps={{
                  name: "mailingAddressId",
                  id: "mailingAddressId",
                }}
              >
                {state.presentAddressData.map((item) => {
                  return (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.Label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          {state.mailingAddressId === 2 && (
            <Fragment>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="presentAddress"
                  name="presentAddress"
                  value={state.presentAddress}
                  error={!!state.presentAddressError}
                  onChange={handleChange}
                  label="Address"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="presentCountryId"
                  getOptionLabel={(option) => option.Label}
                  fullWidth
                  options={state.countriesData}
                  onChange={handleAutoComplete("presentCountryId")}
                  value={state.presentCountryIdObject}
                  renderInput={(params) => (
                    <TextField
                      label="Country"
                      error={!!state.presentCountryIdError}
                      {...params}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="presentProvinceId"
                  getOptionLabel={(option) => option.Label}
                  fullWidth
                  options={state.presentProvinceData}
                  onChange={handleAutoComplete("presentProvinceId")}
                  value={state.presentProvinceIdObject}
                  renderInput={(params) => (
                    <TextField
                      label="Province"
                      error={!!state.presentProvinceIdError}
                      {...params}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  id="presentCityId"
                  getOptionLabel={(option) => option.Label}
                  fullWidth
                  options={state.presentCitiesData}
                  onChange={handleAutoComplete("presentCityId")}
                  value={state.presentCityIdObject}
                  renderInput={(params) => (
                    <TextField
                      label="City"
                      error={!!state.presentCityIdError}
                      {...params}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="presentPostalCode"
                  name="presentPostalCode"
                  value={state.presentPostalCode}
                  error={!!state.presentPostalCodeError}
                  onChange={handleChange}
                  label="Postal Code"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
            </Fragment>
          )}

          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>
              Father&apos;s Information
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: "-20px",
            }}
          >
            <FormControl
              error={!!state.fatherTitleIdError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="fatherTitleId">Title</InputLabel>
              <Select
                id="fatherTitleId"
                name="fatherTitleId"
                value={state.fatherTitleId}
                onChange={handleChange}
                fullWidth
                required
                inputProps={{
                  name: "fatherTitleId",
                  id: "fatherTitleId",
                }}
              >
                {state.fatherTitleData.map((item) => {
                  return (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.Label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: "-20px",
            }}
          >
            <TextField
              id="fatherName"
              name="fatherName"
              value={state.fatherName}
              onChange={handleChange}
              error={!!state.fatherNameError}
              label="Name"
              required
              fullWidth
              onKeyDown={keyPress}
            />
          </Grid>
          {state.fatherTitleId !== 6 && (
            <Fragment>
              <Grid item xs={12} sm={6}>
                <FormControl
                  error={!!state.fatherDocumentTypeIdError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="fatherDocumentTypeId">
                    Identity Document Type
                  </InputLabel>
                  <Select
                    fullWidth
                    id="fatherDocumentTypeId"
                    value={state.fatherDocumentTypeId}
                    onChange={handleChange}
                    name="fatherDocumentTypeId"
                    required
                    inputProps={{
                      name: "fatherDocumentTypeId",
                      id: "fatherDocumentTypeId",
                    }}
                  >
                    {state.documentTypeData.map((item) => {
                      if (item.ID !== 4) {
                        return (
                          <MenuItem key={item.ID} value={item.ID}>
                            {item.Label}
                          </MenuItem>
                        );
                      } else {
                        return <Fragment key={item.ID}></Fragment>;
                      }
                    })}
                  </Select>
                </FormControl>
              </Grid>
              {state.fatherDocumentTypeId === 1 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="fatherCnic"
                    name="fatherCnic"
                    value={state.fatherCnic}
                    onChange={cnicCheckHandling}
                    error={!!state.fatherCnicError}
                    helperText={
                      state.fatherCnic ? state.fatherCnicError : ""
                    }
                    placeholder="e.g xxxx-xxxxxxx-x"
                    label="CNIC"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              {state.fatherDocumentTypeId === 2 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="fatherPassport"
                    name="fatherPassport"
                    value={state.fatherPassport}
                    onChange={handleChange}
                    error={!!state.fatherPassportError}
                    label="Passport#"
                    helperText={
                      state.fatherPassport
                        ? state.fatherPassportError
                        : ""
                    }
                    placeholder="e.g xxxxxxxxx"
                    inputProps={{
                      maxLength: 9,
                    }}
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              {state.fatherDocumentTypeId === 3 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="fatherNicop"
                    name="fatherNicop"
                    value={state.fatherNicop}
                    onChange={cnicCheckHandling}
                    error={!!state.fatherNicopError}
                    helperText={
                      state.fatherNicop
                        ? state.fatherNicopError
                        : ""
                    }
                    placeholder="e.g xxxx-xxxxxxx-x"
                    label="NICOP"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <TextField
                  id="fatherMobileNo"
                  name="fatherMobileNo"
                  value={state.fatherMobileNo}
                  onChange={handleChange}
                  error={!!state.fatherMobileNoError}
                  label="Mobile Number"
                  helperText={
                    state.fatherMobileNo
                      ? state.fatherMobileNoError
                      : ""
                  }
                  placeholder="e.g 03XXXXXXXXX"
                  inputProps={{
                    maxLength: 11,
                  }}
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="fatherEmail"
                  name="fatherEmail"
                  value={state.fatherEmail}
                  onChange={handleChange}
                  helperText={
                    state.fatherEmail ? state.fatherEmailError : ""
                  }
                  error={!!state.fatherEmailError}
                  placeholder="e.g name@domain.com"
                  label="Email"
                  type="email"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl
                  error={!!state.fatherOccupationError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="fatherOccupation">
                    {" "}
                    Father&apos;s Occupation
                  </InputLabel>
                  <Select
                    fullWidth
                    name="fatherOccupation"
                    id="fatherOccupation"
                    value={state.fatherOccupation}
                    onChange={handleChange}
                    required
                    inputProps={{
                      name: "fatherOccupation",
                      id: "fatherOccupation",
                    }}
                  >
                    {state.maleOccupationData.map((item) => {
                      return (
                        <MenuItem key={item.ID} value={item.ID}>
                          {item.Label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Fragment>
          )}

          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>
              Mother&apos;s Information
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: "-20px",
            }}
          >
            <FormControl
              error={!!state.motherTitleIdError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="motherTitleId">Title</InputLabel>
              <Select
                id="motherTitleId"
                name="motherTitleId"
                value={state.motherTitleId}
                onChange={handleChange}
                fullWidth
                required
                inputProps={{
                  name: "motherTitleId",
                  id: "motherTitleId",
                }}
              >
                {state.motherTitleData.map((item) => {
                  return (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.Label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            style={{
              marginTop: "-20px",
            }}
          >
            <TextField
              id="motherName"
              name="motherName"
              value={state.motherName}
              onChange={handleChange}
              error={!!state.motherNameError}
              label="Name"
              required
              fullWidth
              onKeyDown={keyPress}
            />
          </Grid>
          {state.motherTitleId !== 6 && (
            <Fragment>
              <Grid item xs={12} sm={6}>
                <FormControl
                  error={!!state.motherDocumentTypeIdError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="motherDocumentTypeId">
                    Identity Document Type
                  </InputLabel>
                  <Select
                    fullWidth
                    name="motherDocumentTypeId"
                    id="motherDocumentTypeId"
                    value={state.motherDocumentTypeId}
                    onChange={handleChange}
                    required
                    inputProps={{
                      name: "motherDocumentTypeId",
                      id: "motherDocumentTypeId",
                    }}
                  >
                    {state.documentTypeData.map((item) => {
                      if (item.ID !== 4) {
                        return (
                          <MenuItem key={item.ID} value={item.ID}>
                            {item.Label}
                          </MenuItem>
                        );
                      } else {
                        return <Fragment key={item.ID}></Fragment>;
                      }
                    })}
                  </Select>
                </FormControl>
              </Grid>
              {state.motherDocumentTypeId === 1 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="motherCnic"
                    name="motherCnic"
                    value={state.motherCnic}
                    error={!!state.motherCnicError}
                    onChange={cnicCheckHandling}
                    helperText={
                      state.motherCnic ? state.motherCnicError : ""
                    }
                    placeholder="e.g xxxx-xxxxxxx-x"
                    label="CNIC"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              {state.motherDocumentTypeId === 2 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="motherPassport"
                    name="motherPassport"
                    label="Passport#"
                    inputProps={{
                      maxLength: 9,
                    }}
                    value={state.motherPassport}
                    error={!!state.motherPassportError}
                    onChange={handleChange}
                    helperText={
                      state.motherPassport
                        ? state.motherPassportError
                        : ""
                    }
                    placeholder="e.g xxxxxxxxx"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              {state.motherDocumentTypeId === 3 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="motherNicop"
                    name="motherNicop"
                    value={state.motherNicop}
                    error={!!state.motherNicopError}
                    onChange={cnicCheckHandling}
                    helperText={
                      state.motherNicop
                        ? state.motherNicopError
                        : ""
                    }
                    placeholder="e.g xxxx-xxxxxxx-x"
                    label="NICOP"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <TextField
                  id="motherMobileNo"
                  name="motherMobileNo"
                  value={state.motherMobileNo}
                  error={!!state.motherMobileNoError}
                  onChange={handleChange}
                  label="Mobile Number"
                  placeholder="e.g 03XXXXXXXXX"
                  helperText={
                    state.motherMobileNo
                      ? state.motherMobileNoError
                      : ""
                  }
                  inputProps={{
                    maxLength: 11,
                  }}
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="motherEmail"
                  name="motherEmail"
                  value={state.motherEmail}
                  error={!!state.motherEmailError}
                  placeholder="e.g name@domain.com"
                  helperText={
                    state.motherEmail ? state.motherEmailError : ""
                  }
                  onChange={handleChange}
                  label="Email"
                  type="email"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel
                    error={!!state.motherOccupationError}
                    htmlFor="motherOccupation"
                  >
                    {" "}
                    Mother&apos;s Occupation
                  </InputLabel>
                  <Select
                    fullWidth
                    name="motherOccupation"
                    id="motherOccupation"
                    required
                    value={state.motherOccupation}
                    onChange={handleChange}
                    inputProps={{
                      name: "motherOccupation",
                      id: "motherOccupation",
                    }}
                  >
                    {state.allOccupationData.map((item) => {
                      return (
                        <MenuItem key={item.ID} value={item.ID}>
                          {item.Label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Fragment>
          )}
          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>
              Guardian&apos;s Information
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              marginTop: "-20px",
            }}
          >
            <FormControl
              error={!!state.guardianInformationIdError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="guardianInformationId">
                Guardian
              </InputLabel>
              <Select
                name="guardianInformationId"
                id="guardianInformationId"
                value={state.guardianInformationId}
                onChange={handleChange}
                fullWidth
                required
                inputProps={{
                  name: "guardianInformationId",
                  id: "guardianInformationId",
                }}
              >
                {state.guardianInformationData.map((item) => {
                  return (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.Label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          {state.guardianInformationId === 3 && (
            <Fragment>
              <Grid item xs={12} sm={6}>
                <FormControl
                  error={!!state.guardianTitleIdError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="guardianTitleId">Title</InputLabel>
                  <Select
                    id="guardianTitleId"
                    name="guardianTitleId"
                    value={state.guardianTitleId}
                    onChange={handleChange}
                    fullWidth
                    required
                    inputProps={{
                      name: "guardianTitleId",
                      id: "guardianTitleId",
                    }}
                  >
                    {state.guardianTitleData.map((item) => {
                      return (
                        <MenuItem key={item.ID} value={item.ID}>
                          {item.Label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  id="guardianName"
                  name="guardianName"
                  label="Name"
                  type="text"
                  value={state.guardianName}
                  error={!!state.guardianNameError}
                  onChange={handleChange}
                  required
                  fullWidth
                  onKeyDown={keyPress}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControl
                  error={!!state.guardianDocumentTypeIdError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="guardianDocumentTypeId">
                    Identity Document Type
                  </InputLabel>
                  <Select
                    id="guardianDocumentTypeId"
                    value={state.guardianDocumentTypeId}
                    onChange={handleChange}
                    fullWidth
                    name="guardianDocumentTypeId"
                    required
                    inputProps={{
                      name: "guardianDocumentTypeId",
                      id: "guardianDocumentTypeId",
                    }}
                  >
                    {state.documentTypeData.map((item) => {
                      if (item.ID !== 4) {
                        return (
                          <MenuItem key={item.ID} value={item.ID}>
                            {item.Label}
                          </MenuItem>
                        );
                      } else {
                        return <Fragment key={item.ID}></Fragment>;
                      }
                    })}
                  </Select>
                </FormControl>
              </Grid>
              {state.guardianDocumentTypeId === 1 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="guardianCnic"
                    name="guardianCnic"
                    value={state.guardianCnic}
                    error={!!state.guardianCnicError}
                    helperText={
                      state.guardianCnic
                        ? state.guardianCnicError
                        : ""
                    }
                    placeholder="e.g xxxx-xxxxxxx-x"
                    onChange={cnicCheckHandling}
                    label="CNIC"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              {state.guardianDocumentTypeId === 2 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="guardianPassport"
                    name="guardianPassport"
                    label="Passport#"
                    inputProps={{
                      maxLength: 9,
                    }}
                    value={state.guardianPassport}
                    error={!!state.guardianPassportError}
                    onChange={handleChange}
                    helperText={
                      state.guardianPassport
                        ? state.guardianPassportError
                        : ""
                    }
                    placeholder="e.g xxxxxxxxx"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              {state.guardianDocumentTypeId === 3 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="guardianNicop"
                    name="guardianNicop"
                    value={state.guardianNicop}
                    error={!!state.guardianNicopError}
                    onChange={cnicCheckHandling}
                    helperText={
                      state.guardianNicop
                        ? state.guardianNicopError
                        : ""
                    }
                    placeholder="e.g xxxx-xxxxxxx-x"
                    label="NICOP"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <FormControl
                  error={!!state.guardianRelationIdError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="guardianRelationId">
                    Guardian Relationship
                  </InputLabel>
                  <Select
                    fullWidth
                    name="guardianRelationId"
                    id="guardianRelationId"
                    value={state.guardianRelationId}
                    onChange={handleChange}
                    required
                    inputProps={{
                      name: "guardianRelationId",
                      id: "guardianRelationId",
                    }}
                  >
                    {state.GuardianRelationshipData.map((item) => {
                      return (
                        <MenuItem key={item.ID} value={item.ID}>
                          {item.Label}
                        </MenuItem>
                      );
                    })}
                    <MenuItem value={101}>Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {state.guardianRelationId === 101 && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="guardianRelationOther"
                    name="guardianRelationOther"
                    value={state.guardianRelationOther}
                    error={!!state.guardianRelationOtherError}
                    onChange={handleChange}
                    label="Other Relation"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
              )}

              <Grid item xs={12} sm={6}>
                <TextField
                  id="guardianMobileNo"
                  name="guardianMobileNo"
                  label="Mobile Number"
                  placeholder="e.g 03XXXXXXXXX"
                  helperText={
                    state.guardianMobileNo
                      ? state.guardianMobileNoError
                      : ""
                  }
                  value={state.guardianMobileNo}
                  error={!!state.guardianMobileNoError}
                  onChange={handleChange}
                  type="text"
                  inputProps={{
                    maxLength: 11,
                  }}
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="guardianEmail"
                  name="guardianEmail"
                  value={state.guardianEmail}
                  error={!!state.guardianEmailError}
                  helperText={
                    state.guardianEmail
                      ? state.guardianEmailError
                      : ""
                  }
                  onChange={handleChange}
                  placeholder="e.g name@domain.com"
                  label="Email"
                  type="email"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl
                  error={!!state.guardianOccupationError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="guardianOccupation">
                    {" "}
                    Guardian&apos;s Occupation
                  </InputLabel>
                  <Select
                    fullWidth
                    name="guardianOccupation"
                    id="guardianOccupation"
                    value={state.guardianOccupation}
                    onChange={handleChange}
                    required
                    inputProps={{
                      name: "guardianOccupation",
                      id: "guardianOccupation",
                    }}
                  >
                    {state.allOccupationData.map((item) => {
                      return (
                        <MenuItem key={item.ID} value={item.ID}>
                          {item.Label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Fragment>
          )}

          {state.appliedFor === 32 && (
            <Fragment>
              <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>Financial</span>
                <br></br>
                <span
                  style={{
                    fontSize: 14,
                    color: "#636363",
                  }}
                >
                  Name/address/profession of the person(s) responsible for the
                  payment of tuition fee and other expenses
                </span>
              </Grid>
              <Grid
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
                item
                xs={12}
                sm={4}
              >
                <TextField
                  id="nameOfPersonAlevel"
                  name="nameOfPersonAlevel"
                  value={state.nameOfPersonAlevel}
                  error={!!state.nameOfPersonAlevelError}
                  onChange={handleChange}
                  label="Name"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
                item
                xs={12}
                sm={4}
              >
                <TextField
                  id="addressOfPersonAlevel"
                  name="addressOfPersonAlevel"
                  label="Address"
                  value={state.addressOfPersonAlevel}
                  error={!!state.addressOfPersonAlevelError}
                  onChange={handleChange}
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
                item
                xs={12}
                sm={4}
              >
                <TextField
                  id="professionOfPersonAlevel"
                  name="professionOfPersonAlevel"
                  value={state.professionOfPersonAlevel}
                  error={!!state.professionOfPersonAlevelError}
                  onChange={handleChange}
                  label="Profession"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
            </Fragment>
          )}

          {state.appliedFor === 32 && (
            <Fragment>
              <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>Academics</span>
                <br></br>
                <span
                  style={{
                    fontSize: 14,
                    color: "#636363",
                  }}
                >
                  Name and address of school last attended
                </span>
              </Grid>
              <Grid
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
                item
                xs={12}
                sm={6}
              >
                <TextField
                  id="nameOfSchoolAlevel"
                  name="nameOfSchoolAlevel"
                  value={state.nameOfSchoolAlevel}
                  error={!!state.nameOfSchoolAlevelError}
                  onChange={handleChange}
                  label="Name"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
                item
                xs={12}
                sm={6}
              >
                <TextField
                  id="addressOfSchoolAlevel"
                  name="addressOfSchoolAlevel"
                  value={state.addressOfSchoolAlevel}
                  error={!!state.addressOfSchoolAlevelError}
                  onChange={handleChange}
                  label="Address"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>

              <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>
                  ‘O’ Level (or equivalent) examination results. In the ‘Exam
                  Grade’ column write RA if results are awaited and TBT if
                  exams are yet to be taken
                </span>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <TextField
                      id="subjectAcademicAlevel"
                      name="subjectAcademicAlevel"
                      value={state.subjectAcademicAlevel}
                      error={!!state.subjectAcademicAlevelError}
                      onChange={handleChange}
                      label="Subject"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <TextField
                      id="examAcademicAlevel"
                      name="examAcademicAlevel"
                      value={state.examAcademicAlevel}
                      error={!!state.examAcademicAlevelError}
                      onChange={handleChange}
                      label="Exam Title"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <TextField
                      id="boardAcademicAlevel"
                      name="boardAcademicAlevel"
                      value={state.boardAcademicAlevel}
                      error={!!state.boardAcademicAlevelError}
                      onChange={handleChange}
                      label="Board"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <TextField
                      id="sessionAcademicAlevel"
                      name="sessionAcademicAlevel"
                      value={state.sessionAcademicAlevel}
                      error={!!state.sessionAcademicAlevelError}
                      onChange={handleChange}
                      label="Session"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      id="gradeAcademicAlevel"
                      name="gradeAcademicAlevel"
                      value={state.gradeAcademicAlevel}
                      error={!!state.gradeAcademicAlevelError}
                      onChange={handleChange}
                      label="Grade"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={1} style={{ marginTop: 12 }}>
                    <Button
                      onClick={() => onAlevelAcademicAddClick()}
                      variant="contained"
                      id="add-button">
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <span
                style={{
                  color: "#d21010",
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                {state.aLevelAcademicError}
              </span>
              <br></br>
              <span
                style={{
                  color: "#d21010",
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                {state.gradeAcademicAlevelError}
              </span>

              <Grid item xs={12}>
                <AdmissionFormTableView
                  rows={state.aLevelAcademicRecordsArray}
                  columns={[
                    { key: "subject", label: "Subject" },
                    { key: "exam", label: "Exam Title" },
                    { key: "board", label: "Board" },
                    { key: "session", label: "Session" },
                    { key: "grade", label: "Grade" },
                  ]}
                  onRemove={(e, i) => onAlevelAcademicRemoveClick(e, i)}
                />
              </Grid>
            </Fragment>
          )}

          {state.appliedFor !== 32 && (
            <Fragment>
              <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>Academics</span>
              </Grid>
              <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>
                  Section 1: O-Level/FA/FSc/ICom/ICS/High School Diploma
                  (Grade 12) or equivalent
                </span>
                <br></br>
                <span
                  style={{
                    fontSize: 14,
                    color: "#636363",
                  }}
                >
                  State below the results of your subjects. These must include
                  English Language and Maths (if taken). Where applicable the
                  overall grade/marks must also be stated. Tick where
                  appropriate.
                </span>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextField
                      id="academicsNameOfAwardingBodySec1"
                      name="academicsNameOfAwardingBodySec1"
                      value={state.academicsNameOfAwardingBodySec1}
                      error={
                        !!state.academicsNameOfAwardingBodySec1Error
                      }
                      onChange={handleChange}
                      label="Name Of Awarding Body"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      id="academicsNameOfInstitutionSec1"
                      name="academicsNameOfInstitutionSec1"
                      value={state.academicsNameOfInstitutionSec1}
                      error={!!state.academicsNameOfInstitutionSec1Error}
                      onChange={handleChange}
                      label="Name Of Institution"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      id="academicsQualificationSec1"
                      name="academicsQualificationSec1"
                      value={state.academicsQualificationSec1}
                      error={!!state.academicsQualificationSec1Error}
                      onChange={handleChange}
                      label="Qualification"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      id="academicsYearAwardedSec1"
                      name="academicsYearAwardedSec1"
                      value={state.academicsYearAwardedSec1}
                      error={!!state.academicsYearAwardedSec1Error}
                      onChange={handleChange}
                      inputProps={{
                        maxLength: 4,
                      }}
                      label="Year Awarded"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl
                      error={!!state.academicsIsResultAwaitedSec1Error}
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="academicsIsResultAwaitedSec1">
                        Result Awaited
                      </InputLabel>
                      <Select
                        name="academicsIsResultAwaitedSec1"
                        id="academicsIsResultAwaitedSec1"
                        fullWidth
                        required
                        value={state.academicsIsResultAwaitedSec1}
                        onChange={handleChange}
                        inputProps={{
                          name: "academicsIsResultAwaitedSec1",
                          id: "academicsIsResultAwaitedSec1",
                        }}
                      >
                        <MenuItem value={1}>Yes</MenuItem>
                        <MenuItem value={0}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      id="academicsOverallMarksSec1"
                      name="academicsOverallMarksSec1"
                      label="Overall Grade/Marks"
                      value={state.academicsOverallMarksSec1}
                      error={!!state.academicsOverallMarksSec1Error}
                      onChange={handleChange}
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <TextField
                      id="academicSubjectSec1"
                      name="academicSubjectSec1"
                      value={state.academicSubjectSec1}
                      onChange={handleChange}
                      error={!!state.academicSubjectSec1Error}
                      label="Subject"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      id="academicGradeMarksSec1"
                      name="academicGradeMarksSec1"
                      value={state.academicGradeMarksSec1}
                      onChange={handleChange}
                      error={!!state.academicGradeMarksSec1Error}
                      label="Grade / Marks"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={1} style={{ marginTop: 12 }}>
                    <Button variant="contained" id="add-button" onClick={onAcademicAddClick}>
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <span
                style={{
                  color: "#d21010",
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                {state.academicSec1Error}
              </span>
              <span
                style={{
                  color: "#d21010",
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                {state.academicGradeMarksSec1Error}
              </span>

              <Grid item xs={12}>
                <AdmissionFormTableView
                  rows={state.academicRecordsArray}
                  columns={[
                    { key: "subject", label: "Subject" },
                    { key: "gradeMarks", label: "Grade / Marks" },
                  ]}
                  onRemove={(e, i) => onAcademicsRemoveClick(e, i)}
                />
              </Grid>

              <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>
                  Section 2: A-Level/BA/BSc/BCom/BCS/AP Exams after Grade 12
                  or equivalent
                </span>
                <br></br>
                <span
                  style={{
                    fontSize: 14,
                    color: "#636363",
                  }}
                >
                  State below the results of your subjects.Where applicable
                  the overall grade/marks must also be sated.
                </span>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextField
                      id="academicsNameOfAwardingBodySec2"
                      name="academicsNameOfAwardingBodySec2"
                      value={state.academicsNameOfAwardingBodySec2}
                      error={
                        !!state.academicsNameOfAwardingBodySec2Error
                      }
                      onChange={handleChange}
                      label="Name Of Awarding Body"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      id="academicsNameOfInstitutionSec2"
                      name="academicsNameOfInstitutionSec2"
                      value={state.academicsNameOfInstitutionSec2}
                      error={!!state.academicsNameOfInstitutionSec2Error}
                      onChange={handleChange}
                      label="Name Of Institution"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      id="academicsQualificationSec2"
                      name="academicsQualificationSec2"
                      value={state.academicsQualificationSec2}
                      error={!!state.academicsQualificationSec2Error}
                      onChange={handleChange}
                      label="Qualification"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <TextField
                      id="academicsYearAwardedSec2"
                      name="academicsYearAwardedSec2"
                      value={state.academicsYearAwardedSec2}
                      error={!!state.academicsYearAwardedSec2Error}
                      onChange={handleChange}
                      label="Year Awarded"
                      inputProps={{
                        maxLength: 4,
                      }}
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl
                      error={!!state.academicsIsResultAwaitedSec2Error}
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="academicsIsResultAwaitedSec2">
                        Result Awaited
                      </InputLabel>
                      <Select
                        name="academicsIsResultAwaitedSec2"
                        id="academicsIsResultAwaitedSec2"
                        fullWidth
                        required
                        value={state.academicsIsResultAwaitedSec2}
                        onChange={handleChange}
                        inputProps={{
                          name: "academicsIsResultAwaitedSec2",
                          id: "academicsIsResultAwaitedSec2",
                        }}
                      >
                        <MenuItem value={1}>Yes</MenuItem>
                        <MenuItem value={0}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      id="academicsOverallMarksSec2"
                      name="academicsOverallMarksSec2"
                      label="Overall Grade/Marks"
                      value={state.academicsOverallMarksSec2}
                      error={!!state.academicsOverallMarksSec2Error}
                      onChange={handleChange}
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <TextField
                      id="academicSubjectSec2"
                      name="academicSubjectSec2"
                      value={state.academicSubjectSec2}
                      onChange={handleChange}
                      error={!!state.academicSubjectSec2Error}
                      label="Subject"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                      id="academicGradeMarksSec2"
                      name="academicGradeMarksSec2"
                      value={state.academicGradeMarksSec2}
                      onChange={handleChange}
                      error={!!state.academicGradeMarksSec2Error}
                      label="Grade / Marks"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={1} style={{ marginTop: 12 }}>
                    <Button variant="contained" id="add-button" onClick={onAcademicSec2AddClick}>
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <span
                style={{
                  color: "#d21010",
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                {state.academicSec2Error}
              </span>
              <span
                style={{
                  color: "#d21010",
                  marginLeft: 10,
                  marginBottom: 10,
                }}
              >
                {state.academicGradeMarksSec2Error}
              </span>
              <Grid item xs={12}>
                <AdmissionFormTableView
                  rows={state.academicSec2RecordsArray}
                  columns={[
                    { key: "subject", label: "Subject" },
                    { key: "gradeMarks", label: "Grade / Marks" },
                  ]}
                  onRemove={(e, i) => onAcademicsSec2RemoveClick(e, i)}
                />
              </Grid>
            </Fragment>
          )}

          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>Other Qualifications</span>
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              marginTop: "-20px",
              marginBottom: 20,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <TextField
                  id="nameOfAwardingSec3"
                  name="nameOfAwardingSec3"
                  value={state.nameOfAwardingSec3}
                  onChange={handleChange}
                  error={!!state.nameOfAwardingSec3Error}
                  label="Name Of Awarding Body"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  id="nameOfInstitutionSec3"
                  name="nameOfInstitutionSec3"
                  value={state.nameOfInstitutionSec3}
                  onChange={handleChange}
                  error={!!state.nameOfInstitutionSec3Error}
                  label="Name Of Institution"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>

              <Grid item xs={3}>
                <TextField
                  id="nameOfQualificationSec3"
                  name="nameOfQualificationSec3"
                  value={state.nameOfQualificationSec3}
                  onChange={handleChange}
                  error={!!state.nameOfQualificationSec3Error}
                  label="Qualification"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>

              <Grid item xs={1} style={{ marginTop: 12 }}>
                <Button
                  variant="contained"
                  id="add-button"
                  onClick={() => onQualificationAddClick()}>
                  Add
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <AdmissionFormTableView
              rows={state.qualificationRecordsArray}
              columns={[
                { key: "nameAward", label: "Name of Awarding Body" },
                { key: "nameInstitution", label: "Name of Institution" },
                { key: "qualification", label: "Qualification" },
              ]}
              onRemove={(e, i) => onQualificationRemoveClick(e, i)}
            />
          </Grid>

          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>
              Extra and Co-Curricular Activities
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              marginTop: "-20px",
              marginBottom: 20,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <TextField
                  id="nameOfInstitutionActivity"
                  name="nameOfInstitutionActivity"
                  value={state.nameOfInstitutionActivity}
                  error={!!state.nameOfInstitutionActivityError}
                  onChange={handleChange}
                  label="Name Of Institution"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>

              <Grid item xs={2}>
                <TextField
                  id="tenureActivity"
                  name="tenureActivity"
                  value={state.tenureActivity}
                  error={!!state.tenureActivityError}
                  onChange={handleChange}
                  label="Tenure (Months)"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id="mainActivity"
                  name="mainActivity"
                  value={state.mainActivity}
                  error={!!state.mainActivityError}
                  onChange={handleChange}
                  label="Activity"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id="positionActivity"
                  name="positionActivity"
                  value={state.positionActivity}
                  error={!!state.positionActivityError}
                  onChange={handleChange}
                  label="Position"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  id="natureOfPositionActivity"
                  name="natureOfPositionActivity"
                  value={state.natureOfPositionActivity}
                  error={!!state.natureOfPositionActivityError}
                  onChange={handleChange}
                  label="Nature Of Position Held"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>

              <Grid item xs={1} style={{ marginTop: 12 }}>
                <Button onClick={() => onActivityAddClick()} variant="contained" id="add-button">
                  Add
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <AdmissionFormTableView
              rows={state.activityRecordsArray}
              columns={[
                { key: "institution", label: "Name Of Institution" },
                { key: "tenure", label: "Tenure (Months)" },
                { key: "activity", label: "Activity" },
                { key: "position", label: "Position" },
                { key: "nature", label: "Nature of Position Held" },
              ]}
              onRemove={(e, i) => onActivityRemoveClick(e, i)}
            />
          </Grid>

          {state.appliedFor !== 32 && (
            <Fragment>
              <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>Work Experience</span>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={2}>
                    <TextField
                      id="organizationWork"
                      name="organizationWork"
                      value={state.organizationWork}
                      error={!!state.organizationWorkError}
                      onChange={handleChange}
                      label="Organization"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <TextField
                      id="tenureWork"
                      name="tenureWork"
                      value={state.tenureWork}
                      error={!!state.tenureWorkError}
                      onChange={handleChange}
                      label="Tenure (Months)"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      id="mainWork"
                      name="mainWork"
                      value={state.mainWork}
                      error={!!state.mainWorkError}
                      onChange={handleChange}
                      label="Activity"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      id="positionWork"
                      name="positionWork"
                      value={state.positionWork}
                      error={!!state.positionWorkError}
                      onChange={handleChange}
                      label="Position"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      id="natureOfPositionWork"
                      name="natureOfPositionWork"
                      value={state.natureOfPositionWork}
                      error={!!state.natureOfPositionWorkError}
                      onChange={handleChange}
                      label="Nature Of Position Held"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={1} style={{ marginTop: 12 }}>
                    <Button onClick={() => onWorkAddClick()} variant="contained" id="add-button">
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <AdmissionFormTableView
                  rows={state.workRecordsArray}
                  columns={[
                    { key: "organization", label: "Organization" },
                    { key: "tenure", label: "Tenure (Months)" },
                    { key: "activity", label: "Activity" },
                    { key: "position", label: "Position" },
                    { key: "nature", label: "Nature of Position Held" },
                  ]}
                  onRemove={(e, i) => onWorkRemoveClick(e, i)}
                />
              </Grid>
            </Fragment>
          )}
          {state.appliedFor && (
            <Fragment>
              <Grid xs={12} style={{ paddingBottom: 10, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>
                  Subject Selection
                </span>
                <br />
                <span
                  style={{
                    fontSize: 14,
                    color: "#636363",
                  }}
                >
                  Select a minimum of 3 and a maximum of 6 subjects offered for
                  your chosen programme.
                </span>
              </Grid>
              <Grid item xs={12} style={{ marginBottom: 20 }}>
                {state.loadingOfferedCourses ? (
                  <div style={{ padding: 10 }}>
                    <CircularProgress size={20} /> &nbsp; Loading subjects...
                  </div>
                ) : state.offeredCoursesData.length === 0 ? (
                  <div style={{ padding: 10, color: "#666" }}>
                    No subjects are currently offered for the selected programme
                    in the active admission session.
                  </div>
                ) : (
                  <Fragment>
                    <FormGroup>
                      <Grid container spacing={1}>
                        {state.offeredCoursesData.map((course) => {
                          const checked = state.selectedCourseIds.includes(
                            course.ID
                          );
                          return (
                            <Grid item xs={12} sm={6} md={4} key={course.ID}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={checked}
                                    onChange={() =>
                                      handleToggleCourse(course.ID)
                                    }
                                    color="primary"
                                  />
                                }
                                label={course.courseTitle}
                              />
                              {checked && (
                                <input
                                  type="hidden"
                                  name="selectedCourseId"
                                  value={course.ID}
                                />
                              )}
                            </Grid>
                          );
                        })}
                      </Grid>
                    </FormGroup>
                    <div
                      style={{
                        marginTop: 8,
                        fontSize: 13,
                        color: state.selectedCourseIdsError
                          ? "#d32f2f"
                          : "#555",
                      }}
                    >
                      {state.selectedCourseIdsError
                        ? state.selectedCourseIdsError
                        : `Selected ${state.selectedCourseIds.length} of 3-6 required`}
                    </div>
                  </Fragment>
                )}
              </Grid>
            </Fragment>
          )}

          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>
              State the Name(s) and Present status of any relative related to
              UCL or BHS
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              marginTop: "-20px",
              marginBottom: 20,
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <FormControl
                  error={!!state.relationInstitutionUclError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="relationInstitutionUcl">
                    Institution
                  </InputLabel>
                  <Select
                    id="relationInstitutionUcl"
                    name="relationInstitutionUcl"
                    onChange={handleChange}
                    value={state.relationInstitutionUcl}
                    fullWidth
                    required
                    inputProps={{
                      name: "relationInstitutionUcl",
                      id: "relationInstitutionUcl",
                    }}
                  >
                    {state.uclRelativeInstitutionData.map((item) => {
                      return (
                        <MenuItem key={item.ID} value={item.ID}>
                          {item.Label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <TextField
                  id="relationIdUcl"
                  name="relationIdUcl"
                  value={state.relationIdUcl}
                  error={!!state.relationIdUclError}
                  onChange={handleChange}
                  label="Relationship"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl
                  error={!!state.currentStatusUclError}
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="currentStatusUcl">Role</InputLabel>
                  <Select
                    id="currentStatusUcl"
                    name="currentStatusUcl"
                    onChange={handleChange}
                    value={state.currentStatusUcl}
                    fullWidth
                    required
                    inputProps={{
                      name: "currentStatusUcl",
                      id: "currentStatusUcl",
                    }}
                  >
                    {state.uclRelativeRolesData.map((item) => {
                      return (
                        <MenuItem key={item.ID} value={item.ID}>
                          {item.Label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          {state.currentStatusUcl && (
            <Grid
              item
              xs={12}
              style={{
                marginTop: "-20px",
                marginBottom: 20,
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    id="relationNameUcl"
                    name="relationNameUcl"
                    value={state.relationNameUcl}
                    error={!!state.relationNameUclError}
                    onChange={handleChange}
                    label="Name"
                    type="text"
                    onKeyDown={keyPress}
                    fullWidth
                  />
                </Grid>
                {state.currentStatusUcl !== 1 &&
                  state.currentStatusUcl !== 4 && (
                    <Grid item xs={4}>
                      <TextField
                        id="relationDepartmentUcl"
                        name="relationDepartmentUcl"
                        value={state.relationDepartmentUcl}
                        error={!!state.relationDepartmentUclError}
                        onChange={handleChange}
                        label="Department"
                        type="text"
                        onKeyDown={keyPress}
                        fullWidth
                      />
                    </Grid>
                  )}

                {(state.currentStatusUcl === 1 ||
                  state.currentStatusUcl === 4) && (
                    <Grid item xs={4}>
                      <TextField
                        id="relationProgramUcl"
                        name="relationProgramUcl"
                        value={state.relationProgramUcl}
                        error={!!state.relationProgramUclError}
                        onChange={handleChange}
                        label="Programme"
                        type="text"
                        onKeyDown={keyPress}
                        fullWidth
                      />
                    </Grid>
                  )}
                {state.currentStatusUcl !== 1 &&
                  state.currentStatusUcl !== 4 && (
                    <Grid item xs={3}>
                      <TextField
                        id="relationDesignationUcl"
                        name="relationDesignationUcl"
                        value={state.relationDesignationUcl}
                        error={!!state.relationDesignationUclError}
                        onChange={handleChange}
                        label="Designation"
                        type="text"
                        onKeyDown={keyPress}
                        fullWidth
                      />
                    </Grid>
                  )}
                {state.currentStatusUcl === 4 && (
                  <Grid item xs={3}>
                    <TextField
                      id="relationGraduationYearUcl"
                      name="relationGraduationYearUcl"
                      value={state.relationGraduationYearUcl}
                      error={!!state.relationGraduationYearUclError}
                      onChange={handleChange}
                      label="Graduation Year"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                )}
                <Grid item xs={1} style={{ marginTop: 12 }}>
                  <Button
                    onClick={() => onUclRelationAddClick()}
                    variant="contained"
                    id="add-button">
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <AdmissionFormTableView
              rows={state.uclRelationRecordsArray}
              columns={[
                { key: "institution", label: "Institution" },
                { key: "relationship", label: "Relationship" },
                { key: "status", label: "Role" },
                { key: "designation", label: "Designation" },
                { key: "name2", label: "Name" },
                { key: "department", label: "Department" },
                { key: "program", label: "Programme" },
                { key: "year", label: "Graduation Year" },
              ]}
              onRemove={(e, i) => onUclRelationRemoveClick(e, i)}
            />
          </Grid>

          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>
              Do you suffer from any medical condition/allergies ?
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            style={{
              marginTop: "-20px",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  id="checkMedical"
                  name="checkMedical"
                  onChange={(e) => handleCustomChange(e, 1)}
                  checked={state.checkMedical === 1}
                  color="primary"
                />
              }
              label="Yes"
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={3}
            style={{
              marginTop: "-20px",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  id="checkMedical"
                  name="checkMedical"
                  onChange={(e) => handleCustomChange(e, 0)}
                  checked={state.checkMedical === 0}
                  color="primary"
                />
              }
              label="No"
            />
          </Grid>
          {state.checkMedical === 1 && (
            <Fragment>
              <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
                <span className={classes.sectionTitle}>
                  Please give details and emergency Mobile number.
                </span>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: "-20px",
                  marginBottom: 20,
                }}
              >
                <TextField
                  id="medicalCondition"
                  name="medicalCondition"
                  value={state.medicalCondition}
                  error={!!state.medicalConditionError}
                  onChange={handleChange}
                  label="Medical Condition"
                  type="text"
                  onKeyDown={keyPress}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} style={{ marginTop: "-20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <TextField
                      id="medicalName"
                      name="medicalName"
                      value={state.medicalName}
                      error={!!state.medicalNameError}
                      onChange={handleChange}
                      label="Name"
                      type="text"
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl
                      error={!!state.medicalRelationshipIdError}
                      className={classes.formControl}
                    >
                      <InputLabel htmlFor="medicalRelationshipId">
                        Relationship
                      </InputLabel>
                      <Select
                        id="medicalRelationshipId"
                        name="medicalRelationshipId"
                        fullWidth
                        value={state.medicalRelationshipId}
                        onChange={handleChange}
                        required
                        inputProps={{
                          name: "medicalRelationshipId",
                          id: "medicalRelationshipId",
                        }}
                      >
                        {state.relationshipData.map((item) => {
                          if (item.Label !== "Self") {
                            return (
                              <MenuItem key={item.ID} value={item.ID}>
                                {item.Label}
                              </MenuItem>
                            );
                          } else {
                            return (
                              <MenuItem key={item.ID} value={item.ID}>Guardian</MenuItem>
                            );
                          }
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      id="medicalMobileNumber"
                      name="medicalMobileNumber"
                      label="Mobile Number"
                      placeholder="e.g 03XXXXXXXXX"
                      value={state.medicalMobileNumber}
                      error={!!state.medicalMobileNumberError}
                      helperText={
                        state.medicalMobileNumber
                          ? state.medicalMobileNumberError
                          : ""
                      }
                      onChange={handleChange}
                      type="text"
                      inputProps={{
                        maxLength: 11,
                      }}
                      onKeyDown={keyPress}
                      fullWidth
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Fragment>
          )}

          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>
              How did you hear about UCL?
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              marginTop: "-20px",
            }}
          >
            <FormControl
              error={!!state.hearFromError}
              className={classes.formControl}
            >
              <InputLabel htmlFor="hearFrom">Select Source</InputLabel>
              <Select
                name="hearFrom"
                id="hearFrom"
                value={state.hearFrom}
                onChange={handleChange}
                fullWidth
                required
                inputProps={{
                  name: "hearFrom",
                  id: "hearFrom",
                }}
              >
                {state.uclHearAboutData.map((item) => {
                  return (
                    <MenuItem key={item.ID} value={item.ID}>
                      {item.Label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          {state.hearFrom === 1 && (
            <Grid item xs={12}>
              <TextField
                id="hearMagzineName"
                name="hearMagzineName"
                label="Name"
                value={state.hearMagzineName}
                error={!!state.hearMagzineNameError}
                onChange={handleChange}
                type="text"
                onKeyDown={keyPress}
                fullWidth
              />
            </Grid>
          )}
          {state.hearFrom === 5 && (
            <Grid item xs={12}>
              <TextField
                id="hearOtherSource"
                name="hearOtherSource"
                value={state.hearOtherSource}
                error={!!state.hearOtherSourceError}
                onChange={handleChange}
                label="Specify Other Source"
                type="text"
                onKeyDown={keyPress}
                fullWidth
              />
            </Grid>
          )}
          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>
              Clearly state your reasons for applying to UCL in support of
              your application.
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              marginTop: "-10px",
            }}
          >
            <TextField
              id="reasons"
              name="reasons"
              value={state.reasons}
              error={!!state.reasonsError}
              onChange={handleChange}
              label="Reasons"
              helperText={`${state.reasons.length} / 1000`}
              inputProps={{
                maxLength: 1000,
              }}
              multiline
              rows={8}
              variant="outlined"
              fullWidth
            />
          </Grid>

          <Grid xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <span className={classes.sectionTitle}>Undertaking</span>
          </Grid>
          <Grid item xs={12}>
            <div
              style={{
                paddingBottom: 10,
                fontSize: 16,
              }}
            >
              <strong style={{ paddingRight: 10 }}>1.</strong>I confirm that
              the information contained in this form is accurate and complete
              to the best of my knowledge and that the submission of
              inaccurate information can be considered sufficient cause for
              terminating my enrollment at Universal College Lahore (UCL).
            </div>
            <div
              style={{
                paddingBottom: 10,
                fontSize: 16,
              }}
            >
              <strong style={{ paddingRight: 10 }}>2.</strong>I also
              understand that if I am required to submit any
              information/document(s) in support of my application, it is my
              responsibility to obtain it and submit it before the closing
              date.
            </div>
            <div
              style={{
                paddingBottom: 10,
                fontSize: 16,
              }}
            >
              <strong style={{ paddingRight: 10 }}>3.</strong>I shall adhere
              to all the deadline dates set by UCL and keep UCL informed in
              writing about any changes that might occur in my contact
              addresses, e.g., postal/residential, phone numbers (landline as
              well as cell numbers), email, etc. I understand that UCL shall
              not accept any responsibility for any consequences that may
              arise from my failure to comply with the aforesaid;
            </div>
            <div
              style={{
                paddingBottom: 10,
                fontSize: 16,
              }}
            >
              <strong style={{ paddingRight: 10 }}>4.</strong>I also
              understand that, while UCL takes all reasonable steps to ensure
              the safety of the person, property and health of every student,
              UCL cannot and does not undertake to be responsible for any
              harm, loss and or damage that may arise for reason of conditions
              or circumstances beyond the control of UCL.
            </div>
            <div
              style={{
                paddingBottom: 10,
                fontSize: 16,
              }}
            >
              <strong style={{ paddingRight: 10 }}>5.</strong>
              Furthermore, I understand that it is the responsibility of the
              owners of the vehicles to ensure the safety of their vehicles
              and note that UCL cannot and does not undertake to be
              responsible in case of theft and or damage.
            </div>
            <div
              style={{
                paddingBottom: 10,
                fontSize: 16,
              }}
            >
              <strong style={{ paddingRight: 10 }}>6.</strong>
              As parent/guardian of the student, I undertake to have received
              the Fee Structure and Rules and confirm that these have been
              carefully read, understood and found affordable.
            </div>
            <div
              style={{
                paddingBottom: 10,
                fontSize: 16,
              }}
            >
              <strong style={{ paddingRight: 10 }}>7.</strong>
              Tuition fee once paid is not refundable irrespective of whether
              the student leaves the course voluntarily or is asked to leave
              the course on academic, discipline or any other grounds.
            </div>
            <div
              style={{
                paddingBottom: 10,
                fontSize: 16,
              }}
            >
              <strong style={{ paddingRight: 10 }}>8.</strong>
              We (the applicant and the parents including the guardians as the
              case may be) give our unconditional consent to the Universal
              College Lahore to use any of the pictures of the student taken
              during college events/functions for marketing purposes In regard
              to the above, this serves to confirm that Universal College
              Lahore is indemnified by the parent/guardian and the student or
              any other party representing the student.
            </div>
          </Grid>
          <Grid item xs={12} style={{ paddingBottom: 20, paddingTop: 20 }}>
            <FormControlLabel
              control={
                <Checkbox
                  id="iAgreeCheck"
                  color="primary"
                  name="iAgreeCheck"
                  onChange={() =>
                    updateState({
                      iAgreeCheck: !state.iAgreeCheck,
                      iAgreeCheckError: "",
                    })
                  }
                  checked={state.iAgreeCheck}
                />
              }
              label="I agree all terms and conditions."
            />
            <span style={{ color: "#d21010" }}>
              {state.iAgreeCheckError}
            </span>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ paddingBottom: 20, paddingTop: 20, display: "flex" }}
            justifyContent="center"
          >
            <Button
              disabled={state.isLoading}
              onClick={handleOnClick}
              color="primary"
              variant="contained"
              style={{ width: "100%", backgroundColor: "#174A84" }}
            >
              {state.isLoading ? (
                <CircularProgress style={{ color: "white" }} size={24} />
              ) : (
                "Save"
              )}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <form onSubmit={onFormSubmit}>
        <input type="hidden" value={state.appliedFor} name="degreeId" />
        <input
          type="hidden"
          value={state.chessSubDegree}
          name="chessDegreeTransferId"
        />
        <input
          type="hidden"
          value={state.yearAlevel}
          name="alevelAdmissionYear"
        />
        <input
          type="hidden"
          value={state.category}
          name="isTransferCandidate"
        />

        <input type="hidden" value={state.firstName} name="firstName" />
        <input
          type="hidden"
          value={state.middleName}
          name="middleName"
        />
        <input type="hidden" value={state.lastName} name="lastName" />
        <input
          type="hidden"
          value={state.displayName}
          name="displayName"
        />
        <input type="hidden" value={userDob} name="dateOfBirth" />
        <input type="hidden" value={state.genderId} name="genderId" />
        <input type="hidden" value={state.email} name="email" />
        <input type="hidden" value={state.mobileNo} name="mobileNo" />
        <input
          type="hidden"
          value={state.nationalityId}
          name="nationalityId"
        />
        <input
          type="hidden"
          value={state.userMaterialStatusId}
          name="maritalStatusId"
        />
        <input
          type="hidden"
          value={state.userDocumentTypeId}
          name="studentIdentity"
        />
        <input
          type="hidden"
          value={state.userNicopCnicBform}
          name="cnicBform"
        />
        <input
          type="hidden"
          value={state.userNicop}
          name="nicopNumber"
        />
        <input
          type="hidden"
          value={state.userPassport}
          name="passportNumber"
        />
        <input
          type="hidden"
          value={state.userBloodGroupId}
          name="bloodGroupId"
        />

        <input
          type="hidden"
          value={state.permanentAddress}
          name="permanentAddress"
        />
        <input
          type="hidden"
          value={state.permanentCountryId}
          name="permanentCountryId"
        />
        <input
          type="hidden"
          value={state.permanentProvinceId}
          name="permanentProvinceId"
        />
        <input
          type="hidden"
          value={state.permanentCityId}
          name="permanentCityId"
        />
        <input
          type="hidden"
          value={state.permanentPostalCode}
          name="permanentPostalCode"
        />

        <input
          type="hidden"
          value={state.mailingAddressId}
          name="mailingAddressTypeId"
        />
        <input
          type="hidden"
          value={state.presentAddress}
          name="mailingAddress"
        />
        <input
          type="hidden"
          value={state.presentCountryId}
          name="mailingCountryId"
        />
        <input
          type="hidden"
          value={state.presentProvinceId}
          name="mailingProvinceId"
        />
        <input
          type="hidden"
          value={state.presentCityId}
          name="mailingCityId"
        />
        <input
          type="hidden"
          value={state.presentPostalCode}
          name="mailingPostalCode"
        />

        <input
          type="hidden"
          value={state.fatherTitleId}
          name="fatherTitleId"
        />
        <input
          type="hidden"
          value={state.fatherName}
          name="fatherName"
        />
        <input
          type="hidden"
          value={state.fatherDocumentTypeId}
          name="fatherIdentityType"
        />
        <input type="hidden" value={fatherDBCnic} name="fatherCnicPassport" />
        <input
          type="hidden"
          value={state.fatherMobileNo}
          name="fatherMobileNo"
        />
        <input
          type="hidden"
          value={state.fatherEmail}
          name="fatherEmail"
        />
        <input
          type="hidden"
          value={state.fatherOccupation}
          name="fatherOccupationId"
        />

        <input
          type="hidden"
          value={state.motherTitleId}
          name="motherTitleId"
        />
        <input
          type="hidden"
          value={state.motherName}
          name="motherName"
        />
        <input
          type="hidden"
          value={state.motherDocumentTypeId}
          name="motherIdentityType"
        />
        <input type="hidden" value={motherDBCnic} name="motherCnicPassport" />
        <input
          type="hidden"
          value={state.motherMobileNo}
          name="motherMobileNo"
        />
        <input
          type="hidden"
          value={state.motherEmail}
          name="motherEmail"
        />
        <input
          type="hidden"
          value={state.motherOccupation}
          name="motherOccupationId"
        />

        <input
          type="hidden"
          value={state.guardianInformationId}
          name="guardianId"
        />
        <input
          type="hidden"
          value={state.guardianTitleId}
          name="guardianTitleId"
        />
        <input
          type="hidden"
          value={state.guardianName}
          name="guardianName"
        />
        <input
          type="hidden"
          value={state.guardianRelationId}
          name="guardianRelationWithStudentId"
        />
        <input
          type="hidden"
          value={state.guardianDocumentTypeId}
          name="guardianIdentity"
        />
        <input
          type="hidden"
          value={guardianDBCnic}
          name="guardianCnicPassport"
        />
        <input
          type="hidden"
          value={state.guardianMobileNo}
          name="guardianMobileNo"
        />
        <input
          type="hidden"
          value={state.guardianEmail}
          name="guardianEmail"
        />
        <input
          type="hidden"
          value={state.guardianOccupation}
          name="guardianOccupationId"
        />

        <input
          type="hidden"
          value={state.academicsNameOfAwardingBodySec1}
          name="interAwardingBody"
        />
        <input
          type="hidden"
          value={state.academicsNameOfInstitutionSec1}
          name="interInstitution"
        />
        <input
          type="hidden"
          value={state.academicsQualificationSec1}
          name="interQualification"
        />
        <input
          type="hidden"
          value={state.academicsYearAwardedSec1}
          name="interYearAwarded"
        />
        <input
          type="hidden"
          value={state.academicsOverallMarksSec1}
          name="interGradeMarks"
        />
        <input
          type="hidden"
          value={state.academicsIsResultAwaitedSec1}
          name="interIsResultAwaiting"
        />
        {state.academicRecordsArray.map((item, index) => {
          return (
            <Fragment key={index}>
              <input type="hidden" value={item.subject} name="interSubject" />
              <input
                type="hidden"
                value={item.gradeMarks}
                name="interSubjectGradeMarks"
              />
            </Fragment>
          );
        })}

        <input
          type="hidden"
          value={state.academicsNameOfAwardingBodySec2}
          name="bachelorsAwardingBody"
        />
        <input
          type="hidden"
          value={state.academicsNameOfInstitutionSec2}
          name="bachelorsInstitution"
        />
        <input
          type="hidden"
          value={state.academicsQualificationSec2}
          name="bachelorsQualification"
        />
        <input
          type="hidden"
          value={state.academicsYearAwardedSec2}
          name="bachelorsYearAwarded"
        />
        <input
          type="hidden"
          value={state.academicsOverallMarksSec2}
          name="bachelorsGradeMarks"
        />

        <input
          type="hidden"
          value={state.academicsIsResultAwaitedSec2}
          name="bachelorsIsResultAwaiting"
        />
        {state.academicSec2RecordsArray.map((item, index) => {
          return (
            <Fragment key={index}>
              <input
                type="hidden"
                value={item.subject}
                name="bachelorsSubject"
              />
              <input
                type="hidden"
                value={item.gradeMarks}
                name="bachelorsSubjectGradeMarks"
              />
            </Fragment>
          );
        })}

        <input
          type="hidden"
          value={state.nameOfSchoolAlevel}
          name="olevelSchoolName"
        />
        <input
          type="hidden"
          value={state.addressOfSchoolAlevel}
          name="olevelSchoolAddress"
        />
        {state.aLevelAcademicRecordsArray.map((item, index) => {
          return (
            <Fragment key={index}>
              <input
                type="hidden"
                value={item.subject}
                name="oLevelSubject"
              />
              <input type="hidden" value={item.exam} name="oLevelExamTitle" />
              <input type="hidden" value={item.board} name="oLevelBoard" />
              <input
                type="hidden"
                value={item.session}
                name="oLevelSession"
              />
              <input type="hidden" value={item.grade} name="oLevelGrade" />
            </Fragment>
          );
        })}

        {state.workRecordsArray.map((item, index) => {
          return (
            <Fragment key={index}>
              <input
                type="hidden"
                value={item.activity}
                name="workExperienceActivity"
              />
              <input
                type="hidden"
                value={item.organization}
                name="workExperienceOrganization"
              />
              <input
                type="hidden"
                value={item.position}
                name="workExperiencePosition"
              />
              <input
                type="hidden"
                value={item.tenure}
                name="workExperienceTenureMonths"
              />
              <input
                type="hidden"
                value={item.nature}
                name="workExperienceNatureOfPositionHeld"
              />
            </Fragment>
          );
        })}

        {state.activityRecordsArray.map((item, index) => {
          return (
            <Fragment key={index}>
              <input
                type="hidden"
                value={item.activity}
                name="coCurricularActivity"
              />
              <input
                type="hidden"
                value={item.institution}
                name="coCurricularInstitution"
              />
              <input
                type="hidden"
                value={item.position}
                name="coCurricularPosition"
              />
              <input
                type="hidden"
                value={item.tenure}
                name="coCurricularTenureMonths"
              />
              <input
                type="hidden"
                value={item.nature}
                name="coCurricularNatureOfPositionHeld"
              />
            </Fragment>
          );
        })}

        {state.qualificationRecordsArray.map((item, index) => {
          return (
            <Fragment key={index}>
              <input
                type="hidden"
                value={item.nameAward}
                name="otherQualificationAwardingBody"
              />
              <input
                type="hidden"
                value={item.nameInstitution}
                name="otherQualificationInstitution"
              />
              <input
                type="hidden"
                value={item.qualification}
                name="otherQualification"
              />
            </Fragment>
          );
        })}

        {state.uclRelationRecordsArray.map((item, index) => {
          return (
            <Fragment key={index}>
              <input
                type="hidden"
                value={item.uclInstitutionId}
                name="relativeStatusInstitutionId"
              />
              <input
                type="hidden"
                value={item.relationship}
                name="relativeStatusRelationship"
              />
              <input
                type="hidden"
                value={item.uclRoleId}
                name="relativeStatusRoleId"
              />
              <input
                type="hidden"
                value={item.name2}
                name="relativeStatusName"
              />
              <input
                type="hidden"
                value={item.department}
                name="relativeStatusDepartment"
              />
              <input
                type="hidden"
                value={item.program}
                name="relativeStatusProgramme"
              />
              <input
                type="hidden"
                value={item.designation}
                name="relativeStatusDesignation"
              />
              <input
                type="hidden"
                value={item.year || 0}
                name="relativeStatusGraduationYear"
              />
            </Fragment>
          );
        })}

        <input
          type="hidden"
          value={state.nameOfPersonAlevel}
          name="financialName"
        />
        <input
          type="hidden"
          value={state.addressOfPersonAlevel}
          name="financialAddress"
        />
        <input
          type="hidden"
          value={state.professionOfPersonAlevel}
          name="financialProfession"
        />

        <input
          type="hidden"
          value={state.checkMedical}
          name="isAnyMedicalCondition"
        />
        <input
          type="hidden"
          value={state.medicalCondition}
          name="medicalCondition"
        />
        <input
          type="hidden"
          value={state.medicalName}
          name="emergencyContactPersonName"
        />
        <input
          type="hidden"
          value={state.medicalRelationshipId}
          name="emergencyContactRelationshipId"
        />
        <input
          type="hidden"
          value={state.medicalMobileNumber}
          name="emergencyContactNumber"
        />

        <input type="hidden" value={state.hearFrom} name="uclSourceId" />
        <input
          type="hidden"
          value={state.hearOtherSource}
          name="uclOtherSource"
        />
        <input
          type="hidden"
          value={state.hearMagzineName}
          name="uclSourceName"
        />

        <input
          type="hidden"
          value={state.reasons}
          name="reasonsForApplying"
        />

        <button
          style={{ display: "none" }}
          id="submit-button"
          type="submit"
        />
      </form>
    </Fragment>
  );

}

AdmissionForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default AdmissionForm;
